export const CreateActionDTO = {
  name: { type: 'string', description: 'The action name', example: 'Repair', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  price: { type: 'number', format: 'float', description: 'The action price', example: '300.78' },
  type: { type: 'string', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'] },
}

export const CreateRecipeDTO = {
  name: { type: 'string', description: 'The recipe name', example: 'Repair', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  price: { type: 'number', format: 'float', description: 'The recipe price', example: '300.78' },
  type: { type: 'string', example: 'deliver', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'] },
}

export const AddActionsToRecipeDTO = {
  actions: { type: 'array', description: 'Array of actions' },
}

export const AddArticlesToActionDTO = {
  articles: { type: 'array', description: 'Array of articles' },
}

export const AbstractActionFiltersDTO = {
  match_mode: { type: 'string', description: 'The action name', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', description: 'The action name', example: 'Repair', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  price: { type: 'number', format: 'float', description: 'The action price', example: '300.78' },
  type: { type: 'string', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'] },
  contract_eligible: { type: 'boolean' },
}

export const UpdateActionDTO = {
  name: { type: 'string', description: 'The action name', example: 'Repair', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  price: { type: 'number', format: 'float', description: 'The action price', example: '300.78' },
  type: { type: 'string', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'] },
}

export const PatchActionDTO = {
  name: { type: 'string', description: 'The action name', example: 'Repair', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  price: { type: 'number', format: 'float', description: 'The action price', example: '300.78' },
  type: { type: 'string', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'] },
}

export const UpdateActionStatusDTO = {
  status: { type: 'string', description: 'he status of the action', example: 'inactive', options: ['active', 'inactive'] },
}

export const ArticleFiltersDTO = {
  match_mode: { type: 'string', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', example: 'Startmotor', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  sale_price: { type: 'number', format: 'float', example: '50.8' },
  measurement: { type: 'string', example: 'liter', options: ['liter', 'kilogram', 'piece'] },
  minimum_margin: { type: 'number', format: 'integer', example: '50' },
  description: { type: 'string', example: 'description' },
  external_reference: { type: 'string', example: '15432' },
}

export const CreateArticleDTO = {
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  measurement: { type: 'string', example: 'liter', options: ['liter', 'kilogram', 'piece'] },
  minimum_margin: { type: 'number', format: 'integer', description: 'The minimum margin of the article', example: '100' },
  preferred_article_option_id: { type: 'string', description: 'The preferred article option identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '100.1' },
  description: { type: 'string', description: 'The description of the article', example: 'description|null' },
}

export const PatchArticleDTO = {
  name: { type: 'string', description: 'The name of the article', example: 'Oil' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '100.1' },
  measurement: { type: 'string', example: 'liter', options: ['liter', 'kilogram', 'piece'] },
  minimum_margin: { type: 'number', format: 'integer', description: 'The minimum margin of the article', example: '100' },
  purchase_discount: { type: 'number', format: 'float', description: 'The purchase discount', example: '3.8' },
  preferred_article_option_id: { type: 'string', description: 'The preferred article option', example: 'aa000008-0000-0000-0000-000000000000' },
  description: { type: 'string', description: 'The description of the article', example: 'description' },
}

export const CreateSupplierDTO = {
  name: { type: 'string', description: 'The name of the supplier', example: 'TCM', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  external_reference: { type: 'string', description: 'The external reference of the supplier', example: 'b79225e2846', pattern: '.*[a-zA-Z0-9\\s].*' },
}

export const UpdateSupplierDTO = {
  name: { type: 'string', description: 'The name of the supplier', example: 'TCM', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  external_reference: { type: 'string', description: 'The external reference of the supplier', example: 'b79225e2846', pattern: '.*[a-zA-Z0-9\\s].*' },
}

export const CreateSaleHistoryDTO = {
  price: { type: 'number', format: 'float', description: 'The price of the sale history', example: '10.5' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the sale history', example: '100' },
  sale_date: { type: 'string', format: 'date', description: 'Sale date', example: '2024-01-01' },
  ticket_id: { type: 'string', description: 'The ticket identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  measurement: { type: 'string', description: 'measurement', example: 'kilogram', options: ['liter', 'kilogram', 'piece'] },
  article_id: { type: 'string', description: 'The article identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  description: { type: 'string', description: 'The description of the sale history', example: 'description|null' },
}

export const FetchAllSaleHistoriesDTO = {
  article_id: { type: 'string', description: 'Article identifier', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const FetchAllPurchaseHistoriesDTO = {
  article_id: { type: 'string', description: 'Article identifier', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const CreatePurchaseHistoryDTO = {
  price: { type: 'number', format: 'float', description: 'The price of the purchase history', example: '10.7' },
  price_per_unit: { type: 'number', format: 'float', description: 'The price per unit of the purchase history', example: '0.5' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the purchase history', example: '100' },
  purchase_date: { type: 'string', format: 'date', description: 'Purchase date', example: '2024-01-01' },
  supplier_id: { type: 'string', description: 'The supplier identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  article_id: { type: 'string', description: 'The article identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  description: { type: 'string', description: 'The description of the purchase history', example: 'description|null' },
}

export const UpdateArticleOptionStatusDTO = {
  status: { type: 'string', example: 'active', options: ['active', 'inactive'] },
}

export const CreateArticleOptionDTO = {
  brand_name: { type: 'string', description: 'The brand name of the article option', example: 'Shell', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  external_reference: { type: 'string', description: 'The external id of the article option', example: 'b79225e2846', pattern: '.*[a-zA-Z0-9\\s].*' },
  code: { type: 'string', description: 'The code of the article option', example: 'OIL-107', pattern: '.*[a-zA-Z0-9\\-_+\\s]+' },
  purchase_gross_price: { type: 'number', format: 'float', description: 'The purchase gross price of the article option', example: '100.1' },
  purchase_net_price: { type: 'number', format: 'float', description: 'The purchase net price of the article option', example: '80' },
  supplier_id: { type: 'string', format: 'uuid', description: 'The supplier id of the article option', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  article_id: { type: 'string', format: 'uuid', description: 'The article id to associate this option with', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  location: { type: 'string', description: 'The location of the article option', example: 'A3', pattern: '.*[a-zA-Z0-9\\s]+' },
  purchase_discount: { type: 'number', format: 'float', description: 'The purchase discount of the article option', example: '5' },
}

export const PatchArticleOptionDTO = {
  external_reference: { type: 'string' },
  brand_name: { type: 'string' },
  code: { type: 'string' },
  purchase_gross_price: { type: 'number', format: 'float' },
  purchase_net_price: { type: 'number', format: 'float' },
  location: { type: 'string' },
  purchase_discount: { type: 'number', format: 'float' },
}

export const AddArticleOptionToArticleDTO = {
  article_option_ids: { type: 'array', description: 'Array of article options' },
}

export const CreateAddressDTO = {
  street: { type: 'string', description: 'The street of the address.', example: 'Ambystraat', pattern: '.*[a-zA-Z\\s\\-\\`\'].*' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the address.', example: '5' },
  post_code: { type: 'string', description: 'The post code of the address.', example: '5676YU' },
  city: { type: 'string', description: 'The city of the address.', example: 'Amsterdam', pattern: '.*[a-zA-Z\\s\'\\-].*' },
  country: { type: 'string', description: 'The country of the address.', example: 'Netherlands', pattern: '.*[a-zA-Z\\s].*' },
  contact_detail_id: { type: 'string', description: 'The contact detail identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  house_number_extension: { type: 'string', description: 'The house number extension of the address.', example: 'A|null', pattern: '.*[a-zA-Z0-9\\s\\-].*' },
  description: { type: 'string' },
}

export const OrganisationFilterDTO = {
  match_mode: { type: 'string', options: ['and', 'or'] },
  number: { type: 'integer' },
  name: { type: 'string' },
  vat_number: { type: 'string' },
  chamber_of_commerce_number: { type: 'string' },
  status: { type: 'string', options: ['active', 'inactive'] },
  type: { type: 'string', options: ['customer', 'prospect'] },
  supplier: { type: 'boolean' },
  active: { type: 'boolean' },
}

export const AddContactPersonToOrganisationDTO = {
  contact_persons: { type: 'array', description: 'Array of contact persons' },
}

export const AddBranchToOrganisationDTO = {
  branches: { type: 'array', description: 'Array of branches' },
}

export const CreateOrganisationDTO = {
  number: { type: 'number', format: 'integer', description: 'The number of the organisation', example: '23535' },
  name: { type: 'string', description: 'The name of the organisation', example: 'organisation name', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  vat_number: { type: 'string', description: 'The VAT number of the organisation', example: 'NL686798079', pattern: '.*[a-zA-Z0-9\\s].*' },
  chamber_of_commerce_number: { type: 'string', description: 'The chamber of commerce number of the organisation', example: '123456789', pattern: '.*[0-9\\s]+' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive'] },
  type: { type: 'string', example: 'customer', options: ['customer', 'prospect'] },
  payment_method: { type: 'string', description: 'Payment method', example: 'sepa', options: ['cash', 'account', 'sepa'] },
  payment_term: { type: 'string', description: 'Payment term', example: 'days', options: ['sepa', '14 days', '30 days', '60 days'] },
  transport_type: { type: 'string', description: 'Transport type', example: 'per hour', options: ['per_hour', 'per_ride', 'self_transport'] },
  transport_ride_amount: { type: 'number', format: 'float', description: 'The transport ride amount of the organisation', example: '200.5' },
  supplier: { type: 'boolean', description: 'The supplier of the organisation', example: 'false' },
  po_required: { type: 'boolean', example: 'true' },
  active: { type: 'boolean', example: 'true' },
  address_id: { type: 'string', description: 'The address identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  external_reference: { type: 'string', description: 'The external reference of organisation', example: '206c0' },
  invoice_address_id: { type: 'string', description: 'The invoice address identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  description: { type: 'string', description: 'The description of the organisation', example: 'description|null' },
}

export const UpdateOrganisationDTO = {
  name: { type: 'string', description: 'The name of the organisation', example: 'organisation name', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  vat_number: { type: 'string', description: 'The VAT number of the organisation', example: 'NL686798079', pattern: '.*[a-zA-Z0-9\\s].*' },
  chamber_of_commerce_number: { type: 'string', description: 'The chamber of commerce number of the organisation', example: '123456789', pattern: '.*[0-9\\s]+' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive'] },
  type: { type: 'string', example: 'customer', options: ['customer', 'prospect'] },
  payment_method: { type: 'string', description: 'Payment method', example: 'sepa', options: ['cash', 'account', 'sepa'] },
  payment_term: { type: 'string', description: 'Payment term', example: '60 days', options: ['SEPA', '14 days', '30 days', '60 days'] },
  transport_type: { type: 'string', description: 'Transport type', example: 'per_hour', options: ['per_hour', 'per_ride', 'self_transport'] },
  transport_ride_amount: { type: 'number', format: 'float', description: 'The transport ride amount of the organisation', example: '200.5' },
  supplier: { type: 'boolean', description: 'The supplier of the organisation', example: 'false' },
  po_required: { type: 'boolean', example: 'true' },
  active: { type: 'boolean', example: 'true' },
  address_id: { type: 'string', description: 'The address identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  invoice_address_id: { type: 'string', description: 'The invoice address identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  description: { type: 'string', description: 'The description of the organisation', example: 'description|null' },
}

export const PatchOrganisationDTO = {
  name: { type: 'string', description: 'The name of the organisation', example: 'organisation name', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  vat_number: { type: 'string', description: 'The VAT number of the organisation', example: 'NL686798079', pattern: '.*[a-zA-Z0-9\\s].*' },
  chamber_of_commerce_number: { type: 'string', description: 'The chamber of commerce number of the organisation', example: '123456789', pattern: '.*[0-9\\s]+' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive'] },
  type: { type: 'string', example: 'customer', options: ['customer', 'prospect'] },
  payment_method: { type: 'string', description: 'Payment method', example: 'sepa', options: ['cash', 'account', 'sepa'] },
  payment_term: { type: 'string', description: 'Payment term', example: '60 days', options: ['SEPA', '14 days', '30 days', '60 days'] },
  transport_type: { type: 'string', description: 'Transport type', example: 'per_hour', options: ['per_hour', 'per_ride', 'self_transport'] },
  transport_ride_amount: { type: 'number', format: 'float', description: 'The transport ride amount of the organisation', example: '200.5' },
  supplier: { type: 'boolean', description: 'The supplier of the organisation', example: 'false' },
  po_required: { type: 'boolean', example: 'true' },
  active: { type: 'boolean', example: 'true' },
  description: { type: 'string', description: 'The description of the organisation', example: 'description' },
}

export const ContactPersonFilterDTO = {
  match_mode: { type: 'string', description: 'Match mode of the searching', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', description: 'The name of the contact person', example: 'John Doe' },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com' },
  active: { type: 'boolean', example: 'true' },
  middle_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null' },
}

export const CreateOrganisationContactPersonDTO = {
  salutation: { type: 'string', example: 'Mr', options: ['Mr', 'Ms', 'Mrs'] },
  initial: { type: 'string', description: 'The initial of the contact person', example: 'A.', pattern: '.*[A-Z.].*' },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo', pattern: '.*[a-zA-Z\\s]+' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon', pattern: '.*[a-zA-Z\\s]+' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com' },
  active: { type: 'boolean', example: 'true' },
  organisation_id: { type: 'string', description: 'The organisation identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  middle_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '.*[a-zA-Z\\s\\.]+' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null' },
  description: { type: 'string', description: 'The description of the contact person', example: 'some description|null' },
}

export const CreateContactDetailDTO = {
  phone_number: { type: 'string', description: 'The phone number of the contact detail', example: '3100000000', pattern: '31[0-9]{9}' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact detail', example: '3100000000', pattern: '31[0-9]{9}' },
  email: { type: 'string', description: 'The email of the contact detail', example: 'email@gmail.com' },
}

export const SaveOrganisationFileDTO = {
  data: { type: 'string', description: 'File data', example: 'base64-encoded-file-data' },
}

export const CreateActionLabourDTO = {
  total_hours: { type: 'number', format: 'float', description: 'The total hours of the action', example: '50.5' },
  type: { type: 'string', description: 'The type of the action', example: 'fixed', options: ['fixed', 'variable'] },
  assignment_id: { type: 'string', description: 'The assignment identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  assignee_id: { type: 'string', description: 'The assignee identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  date: { type: 'string', format: 'date', description: 'Date cannot be in the past', example: '2025-01-01' },
}

export const AssigneeFiltersDTO = {
  match_mode: { type: 'string', description: 'Match mode of the searching', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', description: 'Name of the assignee', example: 'John' },
  function: { type: 'string', description: 'Function of the assignee', example: 'mechanic', options: ['mechanic'] },
  price_per_hour: { type: 'number', format: 'float', description: 'Price per hour of the assignee', example: '50.6' },
}

export const CreateAssigneeDTO = {
  name: { type: 'string', description: 'The name of the mechanic', example: 'John', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  function: { type: 'string', description: 'The function of the assignee', example: 'mechanic', options: ['mechanic'] },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the assignee', example: '50.5' },
  user_id: { type: 'string', format: 'uuid', description: 'The user of the assignee', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const FetchAllAssignmentsDTO = {
  ticket_id: { type: 'string' },
  assignee_id: { type: 'string' },
}

export const CreateAssignmentDTO = {
  action_id: { type: 'string', description: 'The action identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  ticket_id: { type: 'string', description: 'The ticket identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  type: { type: 'string', description: 'The type of assignment', example: 'variable', options: ['fixed', 'variable'] },
}

export const AddAssigneeToAssignmentDTO = {
  assignees: { type: 'array', description: 'Array of assignees' },
}

export const AddActionLabourToAssignmentDTO = {
  action_labours: { type: 'array', description: 'Array of action labours' },
}

export const CreateCommentDTO = {
  access_level: { type: 'string', description: 'The access level of the comment', example: 'internal', options: ['public', 'internal'] },
  content: { type: 'string', description: 'The content of the comment', example: 'My review' },
  author_id: { type: 'string', description: 'The author identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  ticket_id: { type: 'string', description: 'The ticket identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  type: { type: 'string', description: 'The type of the comment', example: 'user', options: ['user', 'case'] },
}

export const FetchAllCommentsDTO = {
  ticket_id: { type: 'string' },
  access_level: { type: 'string', options: ['public', 'internal', 'all'] },
  type: { type: 'string', options: ['case', 'user'] },
}

export const CreateTicketContactPersonDTO = {
  reference: { type: 'string', options: ['site', 'organisation'] },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo|null', pattern: '/^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+' },
  middle_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/, .*[a-zA-Z\\s\\.]+' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon|null', pattern: '/^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com|null' },
  description: { type: 'string', description: 'The description of the contact person', example: 'some description|null' },
}

export const SiteFiltersDTO = {
  match_mode: { type: 'string', description: 'Match mode of the searching', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', description: 'The name of the site', example: 'VDK Verhuur' },
  city: { type: 'string', description: 'The city of the site', example: 'Amsterdam', pattern: '/[^a-zA-Z\\s\'\\-]/, .*[a-zA-Z\\s\'\\-].*' },
  country: { type: 'string', description: 'The country of the site', example: 'Netherlands', pattern: '/[^a-zA-Z\\s]/, .*[a-zA-Z\\s].*' },
  street: { type: 'string', description: 'The street of the site', example: 'Bloemstraat|null', pattern: '/[^a-zA-Z\\s\\-\\`\']/, .*[a-zA-Z\\s\\-\\`\'].*' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the site', example: '89' },
  house_number_extension: { type: 'string', description: 'The house number extension of the site', example: 'A|null', pattern: '/[^a-zA-Z0-9\\s\\-]/, .*[a-zA-Z0-9\\s\\-\\.\\_\\,]+' },
  post_code: { type: 'string', description: 'The post code of the site', example: '6786PO|null', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  description: { type: 'string', description: 'The description of the site', example: 'description|null' },
}

export const CreateSiteDTO = {
  name: { type: 'string', description: 'The name of the site', example: 'VDK Verhuur' },
  city: { type: 'string', description: 'The city of the site', example: 'Amsterdam', pattern: '/[^a-zA-Z\\s\'\\-]/, .*[a-zA-Z\\s\'\\-].*' },
  country: { type: 'string', description: 'The country of the site', example: 'Netherlands', pattern: '/[^a-zA-Z\\s]/, .*[a-zA-Z\\s].*' },
  street: { type: 'string', description: 'The street of the site', example: 'Bloemstraat|null', pattern: '/[^a-zA-Z\\s\\-\\`\']/, .*[a-zA-Z\\s\\-\\`\'].*' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the site', example: '89' },
  house_number_extension: { type: 'string', description: 'The house number extension of the site', example: 'A|null', pattern: '/[^a-zA-Z0-9\\s\\-]/, .*[a-zA-Z0-9\\s\\-\\.\\_\\,]+' },
  post_code: { type: 'string', description: 'The post code of the site', example: '6786PO|null', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  description: { type: 'string', description: 'The description of the site', example: 'description|null' },
}

export const TicketFiltersDTO = {
  match_mode: { type: 'string', description: 'Match mode of the searching', example: 'and', options: ['and', 'or'] },
  number: { type: 'number', format: 'integer', description: 'Number of the ticket', example: '1' },
  start_date: { type: 'string', format: 'date', description: 'Scheduled start date', example: '2024-01-01' },
  end_date: { type: 'string', format: 'date', description: 'Scheduled end date', example: '2024-01-01' },
  type: { type: 'string', description: 'Type of the ticket', example: 'fixed' },
  title: { type: 'string', description: 'Title of the ticket', example: 'Some title' },
  status_id: { type: 'string', format: 'uuid', description: 'Status of the ticket', example: '7d5dddc1-a397-4cc9-9ec6-f190098f7e0d' },
  priority: { type: 'string', description: 'Priority of the ticket', example: 'medium', options: ['high', 'medium', 'low'] },
  description: { type: 'string', description: 'Description of the ticket', example: 'description' },
  unit_id: { type: 'string', description: 'Search tickets by unit id', example: '7d5dddc1-a397-4cc9-9ec6-f190098f7e0d' },
  assignee_id: { type: 'string', description: 'Search tickets by assignee id', example: '7d5dddc1-a397-4cc9-9ec6-f190098f7e0d' },
}

export const CreateTicketDTO = {
  title: { type: 'string', description: 'The title of the ticket', example: 'new title', pattern: '/^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+' },
  status_id: { type: 'string', format: 'uuid', description: 'The status of the ticket', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the ticket', example: 'fixed', options: ['fixed', 'variable'] },
  priority: { type: 'string', description: 'The priority of the ticket', example: 'high', options: ['high', 'medium', 'lows'] },
  expected_complete_date: { type: 'string', format: 'date', description: 'Expected complete date', example: '2025-01-01|null' },
  scheduled_date: { type: 'string', format: 'date', description: 'Scheduled date cannot be in the past', example: '2025-01-01 00:00:00|null' },
  expected_duration: { type: 'array', description: 'The expected duration of the ticket', example: '[object Object]' },
  unit_id: { type: 'string', description: 'The unit identifier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  assignee_id: { type: 'string', description: 'The assignee identifier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  site_id: { type: 'string', description: 'The site identifier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  description: { type: 'string', description: 'The description of the ticket', example: 'the machine requires service' },
  organisation_id: { type: 'string', description: 'The organisation identifier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  parent_id: { type: 'string', description: 'The parent ticket identifier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  site_contact_person_id: { type: 'string', description: 'The site contact person identifier', example: '8f1ad8ca-3e0f-4553-a010-4e337f602982' },
  organisation_contact_person_id: { type: 'string', description: 'The organisation contact person identifier', example: 'fe8efdb6-5eeb-4ad0-80ec-3a735505882c' },
}

export const UpdateTicketExpectedDurationDTO = {
  expected_duration: { type: 'array', description: 'The expected duration of the ticket', example: '[object Object]' },
}

export const UpdateTicketOrganisationDTO = {
  organisation_id: { type: 'string', format: 'uuid', description: 'The organisation ID to associate with the ticket', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const PatchTicketDTO = {
  type: { type: 'string', example: 'fixed', options: ['fixed'] },
  title: { type: 'string', example: 'some title', pattern: '.*[a-zA-Z\\s]+' },
  priority: { type: 'string', example: 'fixed', options: ['high', 'medium', 'lows'] },
  expected_complete_date: { type: 'string', format: 'date', example: '2025-05-01' },
  expected_duration: { type: 'array', description: 'The expected duration of the ticket', example: '[object Object]' },
  scheduled_date: { type: 'string', format: 'date', example: '2025-05-01' },
  description: { type: 'string', example: 'some description' },
}

export const AddAssigneeToTicketDTO = {
  assignee_id: { type: 'string', description: 'Assignee identifier', example: '86ea1db5-3b9f-4ee7-bb3c-8898e36999bb' },
}

export const AddChildTicketToTicketDTO = {
  children: { type: 'array', description: 'Array of children' },
}

export const AddAssignmentToTicketDTO = {
  assignments: { type: 'array', description: 'Array of assignments' },
}

export const AddContactPersonsToTicketDTO = {
  contact_persons: { type: 'array', description: 'Array of contact persons' },
}

export const AddArticlesToTicketDTO = {
  articles: { type: 'array', ref: 'AddArticlesToTicket' },
}

export const AddAcknowledgementToTicketDTO = {
  first_name: { type: 'string', pattern: '.*[a-zA-Z\\s]+' },
  last_name: { type: 'string', pattern: '.*[a-zA-Z\\s]+' },
  phone_number: { type: 'string', pattern: '31[0-9]{9}' },
  email: { type: 'string' },
  signature_image: { type: 'string', description: 'Digital signature as a Base64-encoded string', example: 'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAAC...' },
  consent: { type: 'boolean' },
}

export const SaveFileDTO = {
  files: { type: 'array', description: 'Array of files' },
}

export const AddSignatureDTO = {
  signature_id: { type: 'string', format: 'uuid', example: '0bd5d11a-9005-462b-a7b9-7084d86a5142' },
}

export const UserFiltersDTO = {
  match_mode: { type: 'string', description: 'Match mode of the searching', example: 'and', options: ['and', 'or'] },
  first_name: { type: 'string', description: 'The first name of the user', example: 'James' },
  last_name: { type: 'string', description: 'The last name of the user', example: 'Wyman' },
  phone_number: { type: 'string', description: 'The phone number of the user', example: '317908086', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the user', example: 'email@gmail.com' },
  status: { type: 'string', description: 'The status of the user', example: 'active', options: ['new', 'active', 'inactive', 'suspended'] },
}

export const CreateUserDTO = {
  first_name: { type: 'string', description: 'The first name of the user', example: 'Leo', pattern: '/^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+' },
  last_name: { type: 'string', description: 'The last name of the user', example: 'Tryon', pattern: '/^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+' },
  phone_number: { type: 'string', description: 'The phone number of the user', example: '317908086', pattern: '/^31[0-9]{9}$/, 31[0-9]{9}' },
  email: { type: 'string', description: 'The email of the user', example: 'email@gmail.com' },
  middle_name: { type: 'string', description: 'The middle name of the user', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/, .*[a-zA-Z\\s\\.]+' },
  assignee_id: { type: 'string', format: 'uuid', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const UpdateTicketOrganisationContactPersonDTO = {
  organisation_contact_person_id: { type: 'string', format: 'uuid', description: 'The organisation contact person ID to associate with the ticket', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const CreateTicketStatusDTO = {
  name: { type: 'string', description: 'The name of the status', example: 'new' },
  visible_on_board: { type: 'boolean', description: 'The visible on board of the status', example: 'true' },
  label: { type: 'string', description: 'The label of the status', example: 'new ticket' },
  business_identifier: { type: 'string', description: 'The business identifier of the status', example: 'NEW' },
}

export const UpdateAssigneeDTO = {
  name: { type: 'string', description: 'Name of the assignee', example: 'John' },
  function: { type: 'string', description: 'Function of the assignee', example: 'mechanic', options: ['mechanic', 'admin'] },
  price_per_hour: { type: 'number', format: 'float', description: 'Price per hour of the assignee', example: '50.6' },
  user_id: { type: 'string', format: 'uuid', description: 'user of the assignee', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const UpdateTicketArticleAssociationPriceDTO = {
  price: { type: 'number', format: 'float', description: 'The price of the article association', example: '99.99' },
}

export const UpdateAssignmentAbstractActionDTO = {
  action_id: { type: 'string', description: 'Abstract action  identifier', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const PatchActionLabourDTO = {
  total_hours: { type: 'number', format: 'float', description: 'The total hours of the action', example: '50.5' },
  date: { type: 'string', format: 'date', description: 'date cannot be in the past', example: '2025-01-01 |null' },
  type: { type: 'string', description: 'The type of the action', example: 'fixed', options: ['fixed', 'variable'] },
}

export const FetchAllBookedHoursDTO = {
  start_date: { type: 'string', format: 'date', example: '2025-01-01|null' },
  end_date: { type: 'string', format: 'date', example: '2025-01-01|null' },
}

export const ActionItemFiltersDTO = {
  match_mode: { type: 'string', example: 'and', options: ['and', 'or'] },
  price: { type: 'number', format: 'float', example: '50.9' },
  quantity: { type: 'number', format: 'integer', example: '100' },
}

export const CreateActionItemDTO = {
  price: { type: 'number', format: 'float', description: 'The price of the action item', example: '50.55' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the action item', example: '100' },
  recipe_id: { type: 'string', description: 'The recipe identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  interval_in_months: { type: 'integer', description: 'The interval in months', example: '4' },
  hourly_running_rate: { type: 'integer', description: 'The hourly running rate', example: '2' },
  running_hours_per_year: { type: 'integer', description: 'The running hours per year', example: '100' },
  running_hour_bat_start: { type: 'integer', description: 'The running hour B at start', example: '10' },
}

export const UpdateActionItemDTO = {
  price: { type: 'number', format: 'float', example: '78.9' },
  quantity: { type: 'number', format: 'integer', example: '100' },
  recipe_id: { type: 'string', format: 'uuid', example: 'b70d45ac-5f77-4f92-b7c7-34a87a692346' },
  interval_in_months: { type: 'integer', description: 'The interval in months', example: '4' },
  hourly_running_rate: { type: 'integer', description: 'The hourly running rate', example: '2' },
  running_hours_per_year: { type: 'integer', description: 'The running hours per year', example: '100' },
  running_hour_bat_start: { type: 'integer', description: 'The running hour B at start', example: '10' },
}

export const CategoryFiltersDTO = {
  name: { type: 'string', example: 'ST - Stapelaar', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
}

export const CategoryDTO = {
  name: { type: 'string', description: 'The name of the category', example: 'new category', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  property_attributes_validation: { type: 'array', description: 'The validation schema for the category property attributes' },
  property_attributes_ui_schema: { type: 'array', description: 'The ui schema for the category property attributes' },
  property_attributes_translations: { type: 'array', description: 'The translation schema for the category property attributes' },
}

export const AddPropertiesDTO = {
  properties: { type: 'array', description: 'Array of properties' },
}

export const AddPropertyAttributesDTO = {
  property_atributes: { type: 'array', description: 'Array of property attributes' },
}

export const CreateContractDTO = {
  type: { type: 'string', example: 'care', options: ['care', 'full_care'] },
  start_date: { type: 'string', format: 'date', description: 'Start date', example: '2024-01-01' },
  period: { type: 'string', description: 'The period of the contract in months', example: '48', options: ['24', '36', '48', '60', '72', '84', 'indefinite'] },
  annual_price_adjustment: { type: 'boolean', description: 'The annual price adjustment of the contract', example: 'true' },
  unit_id: { type: 'string', description: 'The unit identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  contract_holder_id: { type: 'string', description: 'The customer identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_id: { type: 'string', description: 'The supplier identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  description: { type: 'string', description: 'The description of the contract', example: 'description|null' },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the contract', example: '20.5' },
  max_number_of_hours: { type: 'integer', description: 'The max number of hours of the contract', example: '100' },
  reference_number: { type: 'string', description: 'The reference number of the contract', example: '5T' },
  note: { type: 'string', description: 'The note of the contract', example: 'Some note' },
  contract_holder_contact_person_id: { type: 'string', description: 'The contract holder contact person identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_branch_id: { type: 'string', description: 'The operator branch identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const UpdateContractDTO = {
  type: { type: 'string', example: 'care', options: ['care', 'full_care'] },
  period: { type: 'string', description: 'The period of the contract in months', example: '48', options: ['24', '36', '48', '60', '72', '84', 'indefinite'] },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the contract', example: '20.5' },
  max_number_of_hours: { type: 'integer', description: 'The max number of hours of the contract', example: '100' },
  annual_price_adjustment: { type: 'boolean', description: 'The annual price adjustment of the contract', example: 'true' },
  unit_id: { type: 'string', description: 'The unit identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  contract_holder_id: { type: 'string', description: 'The customer identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_id: { type: 'string', description: 'The supplier identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  description: { type: 'string', description: 'The description of the contract', example: 'description' },
  note: { type: 'string', description: 'The note of the contract', example: 'Some note' },
  start_date: { type: 'string', format: 'date', description: 'Start date', example: '2024-01-01' },
  reference_number: { type: 'string', description: 'The reference number of the contract', example: '5T' },
  contract_holder_contact_person_id: { type: 'string', description: 'The contract holder contact person identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_branch_id: { type: 'string', description: 'The operator branch identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const PatchContractDTO = {
  type: { type: 'string', example: 'care', options: ['care', 'full_care'] },
  period: { type: 'string', description: 'The period of the contract', example: '48', options: ['24', '36', '48', '60', '72', '84', 'indefinite'] },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the contract', example: '20.5' },
  max_number_of_hours: { type: 'integer', description: 'The max number of hours of the contract', example: '100' },
  annual_price_adjustment: { type: 'boolean', description: 'The annual price adjustment of the contract', example: 'true' },
  description: { type: 'string', description: 'The description of the contract', example: 'description' },
  note: { type: 'string' },
  start_date: { type: 'string', format: 'date', description: 'Start date', example: '2024-01-01' },
  reference_number: { type: 'string', description: 'The reference number of the contract', example: '5T' },
  contract_holder_contact_person_id: { type: 'string', description: 'The contract holder contact person identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_branch_id: { type: 'string', description: 'The operator branch identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const FetchAllContractsDTO = {
  expiring_soon: { type: 'boolean', example: 'false' },
}

export const UpdateContractStatusDTO = {
  status: { type: 'string', example: 'active', options: ['new', 'offer_sent', 'offer_expired', 'active', 'ended', 'cancelled'] },
}

export const AddActionItemsToContractDTO = {
  action_items: { type: 'array', description: 'Array of action items' },
}

export const UpdateOrAddNoteToContractDTO = {
  note: { type: 'string', format: 'text', example: 'Confirmed contract' },
}

export const AddAcknowledgementToContractDTO = {
  first_name: { type: 'string', pattern: '.*[a-zA-Z\\s]+' },
  last_name: { type: 'string', pattern: '.*[a-zA-Z\\s]+' },
  phone_number: { type: 'string', pattern: '31[0-9]{9}' },
  email: { type: 'string' },
  signature_image: { type: 'string', description: 'Digital signature as a Base64-encoded string', example: 'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAAC...' },
  consent: { type: 'boolean' },
}

export const CreateServiceHistoryDTO = {
  unit_id: { type: 'string' },
  ticket_id: { type: 'string' },
  type: { type: 'string', example: 'safety inspection', options: ['annual inspection', 'safety inspection', 'general', 'maintenance'] },
  service_date: { type: 'string', format: 'date', description: 'Service date', example: '2024-01-01' },
  next_service_date: { type: 'string', format: 'date', description: 'Next service date', example: '2024-01-01' },
  description: { type: 'string' },
}

export const UpdateServiceHistoryDTO = {
  unit_id: { type: 'string', description: 'The unit identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  ticket_id: { type: 'string', description: 'The ticket identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  type: { type: 'string', example: 'safety inspection', options: ['safety inspection', 'general', 'maintenance'] },
  service_date: { type: 'string', format: 'date', description: 'service date', example: '2024-01-01' },
  next_service_date: { type: 'string', format: 'date', description: 'Next service date', example: '2024-01-01' },
  description: { type: 'string', description: 'The description of the contract', example: 'description' },
}

export const AddPropertiesWithAttributesToServiceHistoryDTO = {
  data: { type: 'array', ref: 'AddPropertiesWithAttributesToServiceHistory' },
}

export const CreateMaintenancePackageDTO = {
  name: { type: 'string', description: 'The name of the maintenance package', example: 'new package', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  recipes: { type: 'array', description: 'Array of recipe' },
}

export const UpdateMaintenancePackageDTO = {
  name: { type: 'string', description: 'The name of the maintenance package', example: 'new package', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
}

export const AddRecipesToMaintenancePackageDTO = {
  recipes: { type: 'array', description: 'Array of recipes' },
}

export const CreateUnitDTO = {
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/, .*[a-zA-Z0-9]+' },
  organisation_id: { type: 'string', description: 'The organisation identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  availability_date: { type: 'string', format: 'date', description: 'Availability date', example: '2024-01-01' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  manufactured_year: { type: 'number', format: 'integer', description: 'The manufactured year of the unit', example: '2000' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive', 'deleted'] },
  category_id: { type: 'string', description: 'The category identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '.*[A-Z0-9\\s\\-].*' },
  description: { type: 'string', description: 'The description of the unit', example: 'description|null' },
}

export const UpdateUnitDTO = {
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/, .*[a-zA-Z0-9]+' },
  availability_date: { type: 'string', format: 'date', description: 'Availability date', example: '2024-01-01' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive', 'deleted'] },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '.*[A-Z0-9\\s\\-].*' },
  description: { type: 'string', description: 'The description of the unit', example: 'description|null' },
}

export const PatchUnitDTO = {
  name: { type: 'string', description: 'The name of the unit', example: 'updated name', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/, .*[a-zA-Z0-9]+' },
  availability_date: { type: 'string', format: 'date', description: 'Availability date', example: '2024-01-01' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive', 'deleted'] },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00', pattern: '.*[A-Z0-9\\s\\-].*' },
  description: { type: 'string', description: 'The description of the unit', example: 'description' },
}

export const UnitFiltersDTO = {
  match_mode: { type: 'string', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', example: 'unit one', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/' },
  availability_date: { type: 'string', format: 'date', description: 'Availability date', example: '2024-01-01' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  manufactured_year: { type: 'number', format: 'integer', description: 'The manufactured year of the unit', example: '2000' },
  status: { type: 'string', example: 'active', options: ['active', 'inactive', 'deleted'] },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '.*[A-Z0-9\\-\\s\\—].*' },
  description: { type: 'string', description: 'The description of the unit', example: 'description|null' },
  order_by: { type: 'string', example: 'licensePlatNumber', options: ['fleetNumber', 'name', 'serialNumber', 'availabilityDate', 'manufactureName', 'manufacturedYear', 'status', 'licensePlateNumber'] },
}

export const AddServicePropertyToUnitDTO = {
  service_properties: { type: 'array', description: 'Array of service properties' },
}

export const AddServiceHistoryToUnitDTO = {
  service_histories: { type: 'array', description: 'Array of service histories' },
}

export const CreatePropertyDTO = {
  value: { type: 'string', description: 'The value of the property', example: '48V', pattern: '.*[a-zA-Z0-9\\s\\-/\\.].*' },
  attribute_id: { type: 'string', description: 'The attribute identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const UpdatePropertyDTO = {
  value: { type: 'string', description: 'The value of the property', example: '100', pattern: '.*[a-zA-Z0-9\\s\\-/\\.].*' },
  attribute_id: { type: 'string', description: 'The attribute identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const CreatePropertyAttributeDTO = {
  name: { type: 'string', description: 'The name of the property attribute', example: 'Tyre type', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  data_type: { type: 'string', example: 'string', options: ['string', 'integer', 'double', 'boolean', 'json'] },
}

export const PropertyAttributeFiltersDTO = {
  match_mode: { type: 'string', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', example: 'Tyre type', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  data_type: { type: 'string', example: 'string', options: ['string', 'integer', 'double', 'boolean'] },
}

export const ServicePropertyAttributeFiltersDTO = {
  match_mode: { type: 'string', example: 'and', options: ['and', 'or'] },
  name: { type: 'string', example: 'APK', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  data_type: { type: 'string', example: 'string', options: ['string', 'integer', 'double', 'boolean'] },
}

export const CreateServicePropertyAttributeDTO = {
  name: { type: 'string', description: 'The name of the service property attribute', example: 'APK', pattern: '.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+' },
  data_type: { type: 'string', example: 'string', options: ['string', 'integer', 'double', 'boolean', 'json'] },
  validation: { type: 'array', description: 'The validation of the service property attribute', example: '[object Object]' },
  values: { type: 'array', description: 'The values of the service property attribute', example: '1,2' },
}

export const UpdateUnitStatusDTO = {
  status: { type: 'string', example: 'inactive', options: ['active', 'inactive', 'deleted'] },
}

export const AddFileDTO = {
  files: { type: 'array', description: 'Array of files' },
}

export const CreateAdjustmentDTO = {
  price: { type: 'number', format: 'float', description: 'The price of the adjustment', example: '88.1' },
  category: { type: 'string', example: 'amount', options: ['percentage', 'amount'] },
  type: { type: 'string', example: 'surcharge', options: ['discount', 'surcharge'] },
  description: { type: 'string', description: 'The description of the adjustment', example: 'description|null' },
}

export const CreateTemplateDTO = {
  layout_id: { type: 'string', format: 'uuid', description: 'The layout ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'Template type', example: 'handlebars', options: ['handlebars'] },
  version: { type: 'string', description: 'Template version', example: '1.0.0' },
  date: { type: 'string', format: 'date-time', description: 'Version date', example: '2024-01-01T00:00:00+00:00' },
  content: { type: 'array', description: 'Template content', example: '[object Object]' },
  draft: { type: 'boolean', description: 'Is draft', example: 'true' },
  components: { type: 'array', description: 'Template components', example: '' },
  theme_id: { type: 'string', format: 'uuid', description: 'Theme ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  stylesheet_id: { type: 'string', format: 'uuid', description: 'Stylesheet ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const UpdateTemplateDTO = {
  date: { type: 'string', format: 'date-time', description: 'Version date in ATOM format', example: '2024-01-01T00:00:00+00:00' },
  content: { type: 'array', description: 'Template content' },
  draft: { type: 'boolean', description: 'Draft status', example: 'false' },
  stylesheet_id: { type: 'string', format: 'uuid', description: 'Stylesheet ID' },
}

export const GenerateTemplateDTO = {
  ticket_id: { type: 'string', format: 'uuid', description: 'The ticket id of the receipt', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  contract_id: { type: 'string', format: 'uuid', description: 'The contract id', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', example: 'report', options: ['contract', 'receipt', 'invoice', 'report'] },
  output: { type: 'string', example: 'pdf', options: ['pdf', 'mail', 'img'] },
}

export const AddNewVersionDTO = {
  template_id: { type: 'string', format: 'uuid', description: 'Template ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  layout_id: { type: 'string', format: 'uuid', description: 'Layout ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  date: { type: 'string', format: 'date-time', description: 'Version date in ATOM format', example: '2024-01-01T00:00:00+00:00' },
  content: { type: 'array', description: 'Template content' },
  draft: { type: 'boolean', description: 'Draft status', example: 'false' },
}

export const FetchContentDTO = {
  ticket_id: { type: 'string', format: 'uuid', description: 'The ticket id', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  project: { type: 'string', description: 'Project name', example: 'omnihub' },
  layout: { type: 'string', description: 'Layout name', example: 'ticket_report' },
  version_date: { type: 'string', format: 'date-time', description: 'Version date', example: '2024-01-01T00:00:00Z' },
  theme: { type: 'string', description: 'Theme name', example: 'default' },
}

export const PreviewTemplateDTO = {
  type: { type: 'string', description: 'Template type', example: 'handlebars' },
  attributes: { type: 'array', description: 'Template attributes/data', example: '[object Object]' },
  layout: { type: 'array', description: 'Layout configuration', example: '[object Object]' },
  theme: { type: 'array', description: 'Theme configuration', example: '[object Object]' },
  stylesheet: { type: 'array', description: 'Stylesheet configuration', example: '[object Object]' },
  components: { type: 'array', description: 'Components configuration' },
  plugins: { type: 'array', description: 'Plugins configuration' },
  config: { type: 'array', description: 'Additional configuration', example: '[object Object]' },
}

export const AddComponentToTemplateDTO = {
  component_id: { type: 'string', format: 'uuid', description: 'Component ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const CreateComponentDTO = {
  name: { type: 'string', description: 'Component name', example: 'header' },
  content: { type: 'array', description: 'Component content', example: '[object Object]' },
}

export const UpdateComponentDTO = {
  name: { type: 'string', description: 'Component name', example: 'Header Component' },
  content: { type: 'array', description: 'Component content', example: '[object Object]' },
}

export const CreateLayoutDTO = {
  name: { type: 'string', description: 'Layout name', example: 'Invoice Layout' },
  project_id: { type: 'string', format: 'uuid', description: 'Project ID', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const UpdateLayoutDTO = {
  name: { type: 'string', description: 'Layout name', example: 'Invoice Layout' },
}

export const AddTemplateToLayoutDTO = {
  template_id: { type: 'string', format: 'uuid', description: 'Template ID', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const CreateStylesheetDTO = {
  name: { type: 'string', description: 'Stylesheet name', example: 'Invoice Stylesheet' },
  content: { type: 'array', description: 'Stylesheet content', example: '[object Object]' },
}

export const UpdateStylesheetDTO = {
  name: { type: 'string', description: 'Stylesheet name', example: 'Invoice Stylesheet' },
  content: { type: 'array', description: 'Stylesheet content', example: '[object Object]' },
}

export const AddTemplateToStylesheetDTO = {
  template_id: { type: 'string', format: 'uuid', description: 'Template ID', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const CreateThemeDTO = {
  name: { type: 'string', description: 'Theme name', example: 'Dark Theme' },
  content: { type: 'array', description: 'Theme content', example: '[object Object]' },
}

export const UpdateThemeDTO = {
  name: { type: 'string', description: 'Theme name', example: 'Dark Theme' },
  content: { type: 'array', description: 'Theme content', example: '[object Object]' },
}

export const AddTemplateToThemeDTO = {
  template_id: { type: 'string', format: 'uuid', description: 'Template ID', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const CreateProjectDTO = {
  name: { type: 'string', description: 'Project name', example: 'My Project' },
}

export const UpdateProjectDTO = {
  name: { type: 'string', description: 'Project name', example: 'My Project' },
}

export const SendEmailDTO = {
  ticket_id: { type: 'string', description: 'Ticket identifier', example: '86ea1db5-3b9f-4ee7-bb3c-8898e36999bb' },
  project: { type: 'string', description: 'The project name', example: 'BFF' },
  layout: { type: 'string', description: 'Layout identifier', example: '86ea1db5-3b9f-4ee7-bb3c-8898e36999bb' },
  version_date: { type: 'string', format: 'date time', example: '2025-12-01 00:00:00' },
  theme: { type: 'string', example: 'vdk' },
}

export const SendContractDTO = {
  contract_id: { type: 'string', description: 'Contract identifier', example: '86ea1db5-3b9f-4ee7-bb3c-8898e36999bb' },
  project: { type: 'string', description: 'The project name', example: 'BFF' },
  layout: { type: 'string', description: 'Layout identifier', example: '86ea1db5-3b9f-4ee7-bb3c-8898e36999bb' },
  theme: { type: 'string', example: 'vdk' },
  version_date: { type: 'string', format: 'date time', example: '2025-12-01 00:00:00' },
}

export const FetchActionResponse = {
  id: { type: 'string', description: 'The unique identifier of the action.', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the action.', example: 'action one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  price: { type: 'number', format: 'float', description: 'The price of the action.', example: '45.1' },
  type: { type: 'string', description: 'The type of the action.', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection'] },
  status: { type: 'string', description: 'The status of the action.', example: 'active', options: ['active', 'inactive'] },
  created_at: { type: 'string', format: 'date', description: 'The created date of the action', example: '2024-01-01' },
  articles: { type: 'array', description: 'Array of the articles', ref: 'NestedArticleActionResponse' },
}

export const FetchRecipeResponse = {
  id: { type: 'string', description: 'The unique identifier of the action.', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the action.', example: 'action one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  price: { type: 'number', format: 'float', description: 'The price of the action.', example: '45.2' },
  type: { type: 'string', description: 'The type of the action.', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection'] },
  status: { type: 'string', description: 'The status of the action.', example: 'active', options: ['active', 'inactive'] },
  contract_eligible: { type: 'boolean', example: 'false' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the action', example: '2024-01-01' },
  articles: { type: 'array', description: 'Array of the articles', ref: 'NestedArticleActionResponse' },
  actions: { type: 'array', description: 'Array of the actions', ref: 'NestedActionRecipeResponse' },
}

export const FetchAllActionsResponse = {
  data: { type: 'array', ref: 'FetchActionResponseLite' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllRecipesResponse = {
  data: { type: 'array', ref: 'FetchRecipeResponseLite' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchArticleResponse = {
  id: { type: 'string', description: 'The unique identifier of the article.', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  measurement: { type: 'string', description: 'The measurement of the article', example: 'piece', options: ['liter', 'kilogram', 'piece'] },
  minimum_margin: { type: 'number', format: 'integer', description: 'The minimum margin of the article', example: '100' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '100' },
  description: { type: 'string', description: 'The description of the article', example: 'description|null' },
  preferred_article_option: { type: 'string' },
  article_options: { type: 'array', ref: 'NestedArticleOptionResponse' },
}

export const FetchAllArticlesResponse = {
  data: { type: 'array', ref: 'FetchArticleResponseLite' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchSupplierResponse = {
  id: { type: 'string', description: 'The unique identifier of the supplier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The supplier name', example: 'Fabory', pattern: '/[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  external_reference: { type: 'string', description: 'The external id of the supplier', example: 'b79225e2846' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the supplier', example: '2024-01-01' },
}

export const FetchAllSuppliers = {
  data: { type: 'array', ref: 'FetchSupplierResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllSaleHistoriesResponse = {
  data: { type: 'array', ref: 'FetchSaleHistoryResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllPurchaseHistoriesResponse = {
  data: { type: 'array', ref: 'FetchPurchaseHistoryResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchArticleOptionResponse = {
  id: { type: 'string', description: 'The unique identifier of the article option', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '10.5' },
  measurement: { type: 'string', description: 'The measurement of the article', example: 'liter', options: ['liter', 'kilogram', 'piece'] },
  external_reference: { type: 'string', description: 'The external id of the article option', example: 'b79225e2846', pattern: '/[^a-zA-Z0-9\\s]/' },
  brand_name: { type: 'string', description: 'The brand name of the article', example: 'Shell', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  code: { type: 'string', description: 'The code of the article', example: 'OIL', pattern: '/^[a-zA-Z0-9\\-_+\\s]+$/' },
  purchase_gross_price: { type: 'number', format: 'float', description: 'The purchase gross price of the article', example: '100' },
  purchase_net_price: { type: 'number', format: 'float', description: 'The purchase net price of the article', example: '100' },
  purchase_discount: { type: 'number', format: 'float', description: 'The purchase net price of the article', example: '4.2' },
  location: { type: 'string', description: 'The location of the article', example: 'A3', pattern: '/^[a-zA-Z0-9\\s]+$/' },
  status: { type: 'string', description: 'The status of the article', example: 'active', options: ['active', 'inactive'] },
  supplier: { type: 'object', ref: 'NestedSupplierResponse' },
}

export const FetchAddressResponse = {
  id: { type: 'string', description: 'The unique identifier of the address.', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  street: { type: 'string', description: 'The street of the address.', example: 'Ambystraat', pattern: '/[a-zA-Z\\s\\-\\`\']/' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the address.', example: '5' },
  post_code: { type: 'string', description: 'The post code of the address.', example: '5676YU', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  city: { type: 'string', description: 'The city of the address.', example: 'Amsterdam', pattern: '/[a-zA-Z\\s\'\\-]/' },
  country: { type: 'string', description: 'The country of the address.', example: 'Netherlands', pattern: '/[a-zA-Z\\s]/' },
  contact_detail: { type: 'object', ref: 'NestedContactDetailResponse' },
  house_number_extension: { type: 'string', description: 'The house number extension of the address.', example: 'A|null', pattern: '/[a-zA-Z0-9\\s\\-]/' },
  description: { type: 'string', description: 'The description of the address.', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the address', example: '2024-01-01' },
}

export const FetchAllAddressesResponse = {
  data: { type: 'array', ref: 'FetchAddressResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchOrganisationResponse = {
  id: { type: 'string', description: 'The unique identifier of the organisation', example: 'a5039c7e-88e5-4926-9562-60bcd2f88cee' },
  number: { type: 'number', format: 'integer', description: 'The number of the organisation', example: '23535' },
  name: { type: 'string', description: 'The name of the organisation', example: 'organisation name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  vat_number: { type: 'string', description: 'The VAT number of the organisation', example: 'NL686798079', pattern: '/[a-zA-Z0-9\\s]/' },
  chamber_of_commerce_number: { type: 'string', description: 'The chamber of commerce number of the organisation', example: '123456789', pattern: '/^[0-9\\s]+$/' },
  contact_persons: { type: 'array', ref: 'NestedOrganisationContactPerson' },
  branches: { type: 'array', ref: 'NestedAddressResponse' },
  status: { type: 'string', description: 'The status of the organisation', example: 'active', options: ['active', 'inactive'] },
  type: { type: 'string', description: 'The type of the organisation', example: 'prospect', options: ['customer', 'prospect'] },
  payment_method: { type: 'string', description: 'The payment method of the organisation', example: 'sepa', options: ['cash', 'account', 'sepa'] },
  payment_term: { type: 'string', description: 'The payment term of the organisation', example: '14 days', options: ['SEPA', '14 days', '30 days', '60 days'] },
  transport_type: { type: 'string', description: 'The transport type of the organisation', example: 'per ride', options: ['per hour', 'per ride', 'self transport'] },
  transport_ride_amount: { type: 'number', format: 'float', description: 'The transport ride amount of the organisation', example: '200.1' },
  supplier: { type: 'boolean', description: 'The supplier of the organisation', example: 'false' },
  po_required: { type: 'boolean', description: 'The po required of the organisation', example: 'true' },
  active: { type: 'boolean', description: 'Discribes whether organisation is active or not', example: 'false' },
  address: { type: 'object', ref: 'NestedAddressWithContacDetailResponse' },
  external_reference: { type: 'string', description: 'The external reference of the organisation', example: '3435t|null' },
  invoice_address: { type: 'object', ref: 'NestedAddressWithContacDetailResponse' },
  description: { type: 'string', description: 'The description of the organisation', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the organisation', example: '2024-01-01' },
  files: { type: 'array', ref: 'NestedOrganisationFileResponse' },
}

export const FetchAllOrganisations = {
  data: { type: 'array', ref: 'FetchOrganisationResponseLite' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchOrganisationContactPersonResponse = {
  id: { type: 'string', description: 'The unique identifier of the contact person', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  salutation: { type: 'string', description: 'The salutation of the contact person', example: 'Mr', options: ['Mr', 'Ms', 'Mrs'] },
  initial: { type: 'string', description: 'The initial of the contact person', example: 'A.', pattern: '/[^A-Z.]/' },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo', pattern: '/^[a-zA-Z\\s]+$/' },
  midlet_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon', pattern: '/^[a-zA-Z\\s]+$/' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com' },
  active: { type: 'boolean', description: 'The active of the contact person', example: 'true' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
  description: { type: 'string', description: 'The description of the contact person', example: 'some description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the organisation contact person', example: '2024-01-01' },
}

export const FetchAllOrganisationContactPersonsResponse = {
  data: { type: 'array', ref: 'FetchOrganisationContactPersonResponse' },
  page: { type: 'integer', description: 'Specifies thr current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllContactPersonsByOrganisationId = {
  id: { type: 'string', description: 'The unique identifier of the contact person', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  salutation: { type: 'string', description: 'The salutation of the contact person', example: 'Mr', options: ['Mr', 'Ms', 'Mrs'] },
  initial: { type: 'string', description: 'The initial of the contact person', example: 'J.G.', pattern: '/[^A-Z.]/' },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo', pattern: '/^[a-zA-Z\\s]+$/' },
  midlet_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon', pattern: '/^[a-zA-Z\\s]+$/' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com' },
  active: { type: 'boolean', description: 'The active of the contact person', example: 'true' },
  description: { type: 'string', description: 'The description of the contact person', example: 'some description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the organisation contact person', example: '2024-01-01' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
}

export const FetchAllOrganisationBranchesResponse = {
  data: { type: 'array', ref: 'FetchAddressResponse' },
}

export const FetchActionLabourResponse = {
  id: { type: 'string', description: 'The unique identifier of the action labour', example: 'dc82adb4-cb0d-466b-91bb-cae3d437aaa6' },
  total_hours: { type: 'number', format: 'float', description: 'The total hours of the action labour', example: '10.1' },
  type: { type: 'string', description: 'The type of the action labour', example: 'fixed', options: ['fixed', 'variable'] },
  date: { type: 'date', description: 'The date of the action labour', example: '2026-04-12' },
  assignment: { type: 'object', ref: 'NestedAssignmentResponse' },
  assignee: { type: 'object', ref: 'NestedAssigneeResponse' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the action labour', example: '2024-01-01' },
}

export const FetchAllActionLabours = {
  data: { type: 'array', ref: 'FetchActionLabourResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const UpdateActionLabourTotalHours = {
  total_hours: { type: 'number', format: 'float', description: 'The total hours of the action labour', example: '46.9' },
}

export const FetchAssigneeResponse = {
  id: { type: 'string', description: 'The unique identifier of the assignee', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the assignee', example: 'Yan', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  function: { type: 'string', description: 'The function of the assignee', example: 'mechanic', options: ['mechanic'] },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the assignee', example: '70.55' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the assignee', example: '2024-01-01' },
  user: { type: 'object', ref: 'NestedUserResponse' },
}

export const FetchAllAssignees = {
  data: { type: 'array', ref: 'FetchAssigneeResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAssignmentResponse = {
  id: { type: 'string', description: 'The unique identifier of the assignment', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  status: { type: 'string', description: 'The status of the assignment', example: 'open', options: ['open', 'closed'] },
  type: { type: 'string', description: 'The type of the assignment', example: 'fixed', options: ['fixed', 'variable'] },
  action: { type: 'object', ref: 'NestedActionResponse' },
  action_labours: { type: 'array', ref: 'NestedActionLabourResponse' },
  assignees: { type: 'array', ref: 'NestedAssigneeResponse' },
  ticket: { type: 'object', ref: 'NestedTicketResponse' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the assignment', example: '2024-01-01' },
}

export const FetchAllAssignments = {
  data: { type: 'array', ref: 'FetchAssignmentResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllComments = {
  data: { type: 'array', ref: 'FetchCommentResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchTicketContactPersonResponse = {
  id: { type: 'string', description: 'The unique identifier of the contact person', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  reference: { type: 'string', description: 'The type of the contract', example: 'site', options: ['site', 'organisation'] },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo|null', pattern: '/^[a-zA-Z\\s]+$/' },
  middle_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon|null', pattern: '/^[a-zA-Z\\s]+$/' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com|null' },
  description: { type: 'string', description: 'The description of the contact person', example: 'some description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the contact person', example: '2024-01-01' },
}

export const FetchAllTicketContactPersonsResponse = {
  data: { type: 'array', ref: 'FetchTicketContactPersonResponse' },
  page: { type: 'integer', description: 'Specifies thr current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchSiteResponse = {
  id: { type: 'string', description: 'The unique identifier of the site', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the site', example: 'VDK Verhuur' },
  street: { type: 'string', description: 'The street of the site', example: 'Bloemstraat|null', pattern: '/[^a-zA-Z\\s\\-\\`\']/' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the site', example: '89' },
  house_number_extension: { type: 'string', description: 'The house number extension of the site', example: 'A|null', pattern: '/[^a-zA-Z0-9\\s\\-]/' },
  post_code: { type: 'string', description: 'The post code of the site', example: '6786PO|null', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  city: { type: 'string', description: 'The city of the site', example: 'Amsterdam', pattern: '/[^a-zA-Z\\s\'\\-]/' },
  country: { type: 'string', description: 'The country of the site', example: 'Netherlands', pattern: '/[^a-zA-Z\\s]/' },
  description: { type: 'string', description: 'The description of the site', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the site', example: '2024-01-01' },
}

export const FetchAllSites = {
  data: { type: 'array', ref: 'FetchSiteResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchTicketResponse = {
  id: { type: 'string', description: 'The unique identifier of the ticket', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the ticket', example: 'fixed', options: ['fixed', 'variable'] },
  title: { type: 'string', description: 'The title of the ticket', example: 'new title', pattern: '/^[a-zA-Z\\s]+$/' },
  number: { type: 'number', format: 'integer', description: 'The number of the ticket', example: '10' },
  status: { type: 'object', ref: 'NestedTicketStatus' },
  status_detail: { type: 'object', ref: 'NestedTicketStatusDetail' },
  priority: { type: 'string', description: 'The priority of the ticket', example: 'medium|null', options: ['high', 'medium', 'lows'] },
  expected_complete_date: { type: 'string', format: 'date', description: 'The expected complete date of the ticket', example: '2000-01-01|null' },
  expected_duration: { type: 'object', description: 'The expected duration of the ticket', example: '[object Object]' },
  pinned: { type: 'boolean', example: 'false' },
  scheduled_date: { type: 'string', format: 'dateTime', description: 'Scheduled date cannot be in the past', example: '2025-01-01 09:00:00|null' },
  unit: { type: 'string' },
  assignee: { type: 'string' },
  site: { type: 'string' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
  description: { type: 'string', description: 'The description of the ticket', example: 'the machine requires service' },
  assignments: { type: 'array', ref: 'NestedAssignmentResponse2' },
  children: { type: 'array', ref: 'NestedTicketResponse' },
  parent: { type: 'string' },
  comments: { type: 'array', ref: 'NestedCommentResponse' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the ticket', example: '2024-01-01' },
  articles: { type: 'array', ref: 'NestedTicketArticleResponse' },
  site_contact_persons: { type: 'array', ref: 'NestedTicketContactPerson' },
  organisation_contact_persons: { type: 'array', ref: 'NestedTicketContactPerson' },
  files: { type: 'array', ref: 'NestedFileResponse' },
  acknowledgement: { type: 'string' },
  case: { type: 'string' },
  case_detail: { type: 'object', ref: 'NestedCaseDetail' },
}

export const FetchAllTickets = {
  data: { type: 'array', ref: 'FetchTicketResponseFull' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllScheduledTickets = {
  data: { type: 'array', ref: 'FetchTicketResponseFull' },
}

export const UpdateTicketTitle = {
  title: { type: 'string', description: 'The title of the ticket', example: 'Updated ticket 1', pattern: '/[a-zA-Z\\s]+$/' },
}

export const UpdateTicketDescription = {
  description: { type: 'string', description: 'The description of the ticket', example: 'updated description' },
}

export const UpdateTicketPriority = {
  priority: { type: 'string', description: 'The priority of the ticket', example: 'high', options: ['high', 'medium', 'lows'] },
}

export const ScheduleTicket = {
  scheduled_date: { type: 'string', format: 'date', description: 'Scheduled date cannot be in the past', example: '2025-01-01' },
}

export const UpdateTicketStatus = {
  status_id: { type: 'string', format: 'uuid', description: 'The status of the ticket', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
  status_detail_id: { type: 'string', format: 'uuid', description: 'The status detail of the ticket', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const UpdateTicketAssignee = {
  assignee_id: { type: 'string', format: 'uuid', description: 'Assignee identifier', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const UpdateTicketExpectedDuration = {
  expected_duration: { type: 'object', description: 'The expected duration of the ticket' },
}

export const UpdateTicketOrganisation = {
  organisation_id: { type: 'string', format: 'uuid', description: 'The organisation ID to associate with the ticket', example: 'f6edd4cd-7726-456d-ad26-872cd4dcc437' },
}

export const AddAcknowledgementToTicket = {
  first_name: { type: 'string', description: 'Signer first name', example: 'John' },
  last_name: { type: 'string', description: 'Signer last name', example: 'Doe' },
  phone_number: { type: 'string', description: 'Signer phone number', example: '31612345678' },
  email: { type: 'string', description: 'Signer email address', example: 'test@mail.com' },
  signature_image: { type: 'string', description: 'Signature image in base64 format', example: 'iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB8E1zBAAAgAElEQVR4nOy9d3wU5b7Hv' },
  consent: { type: 'boolean', description: 'Signature image in base64 format', example: 'true' },
}

export const AddCaseToTicket = {
  comment: { type: 'string', format: 'text', description: 'A comment that describes the case', example: 'The ticket is done' },
  case_id: { type: 'string', format: 'uuid', description: 'The case id', example: '40b2628a-fc49-41d1-bde8-dcd0f04a51b6' },
  case_detail_id: { type: 'string', format: 'uuid', description: 'The case detail id', example: '40b2628a-fc49-41d1-bde8-dcd0f04a51b6' },
}

export const NestedSignature = {
  id: { type: 'string', description: 'The unique identifier of the signature', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const FetchFileResponse = {
  file: { type: 'string', format: 'json', description: 'The file of the image', example: '{id:464d20b4-5dd4-4382-91cd-40bbc795ae21,type:image,filename:test.jpg,mimeType:image/jpeg,uri:https://example.com/filename.jpg,size:1024b}' },
}

export const FetchUserResponse = {
  id: { type: 'string', description: 'The unique identifier of the user', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  first_name: { type: 'string', description: 'The first name of the user', example: 'Leo', pattern: '/^[a-zA-Z\\s]+$/' },
  middle_name: { type: 'string', description: 'The middle name of the user', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
  last_name: { type: 'string', description: 'The last name of the user', example: 'Tryon', pattern: '/^[a-zA-Z\\s]+$/' },
  phone_number: { type: 'string', description: 'The phone number of the user', example: '317908086', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the user', example: 'email@gmail.com' },
  status: { type: 'string', description: 'The status of the user', example: 'active', options: ['new', 'active', 'inactive', 'suspended'] },
  created_at: { type: 'string', format: 'date', description: 'The created date of the user', example: '2024-01-01' },
  assignee: { type: 'object', ref: 'NestedUserAssigneeResponse' },
}

export const FetchAllUsers = {
  data: { type: 'array', ref: 'FetchUserResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const UpdateTicketSiteContactPerson = {
  site_contact_person_id: { type: 'string', description: 'The unique identifier of the site contact person', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const FetchAllTicketStatus = {
  data: { type: 'array', ref: 'FetchTicketStatusResponse' },
}

export const UpdateTicketArticleAssociationQuantity = {
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the article association', example: '5' },
}

export const FetchAllBookedHours = {
  data: { type: 'array', description: 'Booked hours grouped by date. Each key is a date string (YYYY-MM-DD) and the value is an array of booked hours for that date.', example: '[object Object]', ref: 'FetchBookedHoursResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchActionItemResponse = {
  id: { type: 'string', description: 'The unique identifier of the action item', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  price: { type: 'number', format: 'float', description: 'The price of the action item', example: '50.55' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the action item', example: '100' },
  interval_in_months: { type: 'number', format: 'integer', description: 'The interval in months of the action item' },
  hourly_running_rate: { type: 'number', format: 'integer', description: 'The hourly running rate of the action item' },
  running_hours_per_year: { type: 'number', format: 'integer', description: 'The running hours per year of the action item' },
  running_hour_bat_start: { type: 'number', format: 'integer', description: 'The running hour B at start of the action item' },
  recipe: { type: 'object', ref: 'NestedRecipeResponse' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the action item', example: '2024-04-01' },
}

export const FetchAllActionItems = {
  data: { type: 'array', ref: 'FetchActionItemResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchCategoryResponse = {
  id: { type: 'string', description: 'The unique identifier of the category', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the category', example: 'new category', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  properties: { type: 'array', ref: 'NestedPropertyResponse' },
  property_attributes: { type: 'array', ref: 'NestedPropertyAttributeResponse' },
  propertyproperty_attributes_validation: { type: 'array', description: 'The validation of the property attributes' },
  property_attributes_ui_schema: { type: 'array', description: 'The ui schema of the property attributes ' },
  property_attributes_translations: { type: 'array', description: 'The translations of the property attributes ' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the category', example: '2024-04-01' },
}

export const FetchAllCategoriesResponse = {
  data: { type: 'array', ref: 'FetchCategoryResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchContractResponse = {
  id: { type: 'string', description: 'The unique identifier of the contract', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the contract', example: 'care', options: ['care', 'full_care'] },
  number: { type: 'number', format: 'integer', description: 'The number of the contract', example: '6870' },
  status: { type: 'string', description: 'The status of the contract', example: 'new', options: ['new', 'active', 'offer', 'ended', 'cancelled', 'expired'] },
  start_date: { type: 'string', format: 'date', description: 'The start date of the contract', example: '2000-01-01' },
  period: { type: 'string', description: 'The period of the contract', example: '48 months', options: ['24 months', '36 months', '48 months', '60 months', '72 months', '84 months', 'indefinite'] },
  end_date: { type: 'string', format: 'date', description: 'The end date of the contract', example: '2000-01-01' },
  annual_price_adjustment: { type: 'boolean', description: 'The annual price adjustment of the contract', example: 'true' },
  unit: { type: 'object', ref: 'NestedUnitResponse' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
  supplier: { type: 'object', ref: 'NestedOrganisationResponse' },
  action_items: { type: 'array', ref: 'NestedActionItemResponse' },
  description: { type: 'string', description: 'The description of the contract', example: 'description|null' },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the contract', example: '20.5' },
  max_number_of_hours: { type: 'integer', description: 'The max number of hours of the contract', example: '100' },
  reference_number: { type: 'string', description: 'The reference number of the contract', example: '59' },
  note: { type: 'string', description: 'The note of the contract', example: 'unsigned contract' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the contract', example: '2024-04-01' },
  files: { type: 'array', ref: 'NestedContractFileResponse' },
  acknowledgement: { type: 'object', ref: 'NestedAcknowledgement' },
  organisation_detail: { type: 'string' },
  unit_detail: { type: 'string' },
  supplier_detail: { type: 'string' },
  action_items_detail: { type: 'array', ref: 'NestedActionItemsDetailResponse' },
  contract_holder_contact_person_id: { type: 'string', description: 'The contract holder contact person identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_branch_id: { type: 'string', description: 'The operator branch identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const FetchAllContracts = {
  data: { type: 'array', ref: 'FetchContractResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const AddAcknowledgementToContract = {
  first_name: { type: 'string', description: 'Signer first name', example: 'John' },
  last_name: { type: 'string', description: 'Signer last name', example: 'Doe' },
  phone_number: { type: 'string', description: 'Signer phone number', example: '31612345678' },
  email: { type: 'string', description: 'Signer email address', example: 'test@mail.com' },
  signature_image: { type: 'string', description: 'Signature image in base64 format', example: 'iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB8E1zBAAAgAElEQVR4nOy9d3wU5b7Hv' },
  consent: { type: 'boolean', description: 'Signature image in base64 format', example: 'true' },
}

export const FetchServiceHistoryResponse = {
  id: { type: 'string', description: 'The unique identifier of the inspection history', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  unit: { type: 'object', ref: 'NestedUnitResponse' },
  ticket_id: { type: 'string', description: 'The unique identifier of the ticket in the inspection history', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the inspection history', example: 'safety inspection', options: ['safety inspection', 'part replacement'] },
  service_date: { type: 'string', format: 'date', description: 'The inspection date of the inspection history', example: '2024-09-01' },
  next_service_date: { type: 'string', format: 'date', description: 'The next inspection date of the inspection history', example: '2024-12-01' },
  properties: { type: 'array', ref: 'NestedServicePropertyResponse' },
  description: { type: 'string', description: 'The description of the inspection history', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the inspection history', example: '2024-04-01' },
}

export const FetchAllServiceHistoriesResponse = {
  data: { type: 'array', ref: 'FetchServiceHistoryResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchMaintenancePackageResponse = {
  id: { type: 'string', description: 'Teh unique identifier of the maintenance package', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the maintenance package', example: 'new package', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  recipes: { type: 'array', ref: 'NestedRecipeResponse' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the maintenance package', example: '2024-04-01' },
}

export const FetchAllMaintenancePackagesResponse = {
  data: { type: 'array', ref: 'FetchMaintenancePackageResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchUnitResponse = {
  id: { type: 'string', description: 'The unique identifier of the unit', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/' },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '/^[A-Z0-9\\s\\-]/' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
  availability_date: { type: 'string', format: 'date', description: 'The availability date of the unit', example: '2000-01-01' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  manufactured_year: { type: 'number', format: 'integer', description: 'The manufactured year of the unit', example: '2000' },
  status: { type: 'string', description: 'The status of the unit', example: 'active', options: ['active', 'inactive', 'deleted'] },
  category: { type: 'object', ref: 'NestedCategoryResponse' },
  properties: { type: 'array', ref: 'NestedPropertyResponse' },
  service_properties: { type: 'array', ref: 'NestedUnitServicePropertyResponse' },
  service_histories: { type: 'array', ref: 'NestedServiceHistoryResponse' },
  contracts: { type: 'array', ref: 'NestedContractResponse' },
  description: { type: 'string', description: 'The description of the unit', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the unit', example: '2024-04-01' },
  tickets: { type: 'array', example: 'c691f356-6df0-45e8-add7-326c74e34017' },
}

export const FetchAllUnits = {
  data: { type: 'array', ref: 'FetchUnitResponseLite' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchPropertyResponse = {
  id: { type: 'string', description: 'The unique identifier of the property', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  value: { type: 'string', description: 'The value of the property', example: '48V', pattern: '/[^a-zA-Z0-9\\s\\-\\/\\.]/' },
  attribute: { type: 'object', ref: 'NestedPropertyAttributeResponse2' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the property', example: '2020-01-01' },
}

export const FetchAllPropertiesResponse = {
  data: { type: 'array', ref: 'FetchPropertyResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchAllPropertyAttributes = {
  data: { type: 'array', ref: 'FetchPropertyAttributeResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const FetchServicePropertyAttributeResponse = {
  id: { type: 'string', description: 'The unique identifier of the service property attribute', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the service property attribute', example: 'APK', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  data_type: { type: 'string', description: 'The data type of the service property attribute', example: 'string', options: ['string', 'integer', 'double', 'boolean'] },
  validation: { type: 'array', description: 'The validation of the service property attribute', example: 'APK' },
  values: { type: 'array', description: 'The values of the service property attribute', example: 'Every year,Once every two years' },
}

export const FetchAllServicePropertyAttributesResponse = {
  data: { type: 'array', ref: 'FetchServicePropertyAttributeResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '2' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '2' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages', example: '5' },
}

export const FetchPropertyAttributeResponse = {
  id: { type: 'string', description: 'The unique identifier of the property attribute', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the property attribute', example: 'Tyre type', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  data_type: { type: 'string', description: 'The data type of the property attribute', example: 'integer', options: ['string', 'integer', 'double', 'boolean'] },
}

export const FetchAllCases = {
  data: { type: 'array', ref: 'FetchCaseResponse' },
}

export const FetchAdjustmentResponse = {
  id: { type: 'string', description: 'The unique identifier of the adjustment', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  price: { type: 'number', format: 'float', description: 'The price of the adjustment', example: '78.3' },
  category: { type: 'string', description: 'The category of the adjustment', example: 'amount', options: ['percentage', 'amount'] },
  type: { type: 'string', description: 'The type of the adjustment', example: 'discount', options: ['discount', 'surcharge'] },
  description: { type: 'string', description: 'The description of the adjustment', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the adjustment', example: '2025-01-01' },
}

export const FetchAllAdjustments = {
  data: { type: 'array', ref: 'FetchAdjustmentResponse' },
  page: { type: 'integer', description: 'Specifies the current page number in a paginated list. Used for fetching and displaying a specific subset of records', example: '1' },
  limit: { type: 'integer', description: 'Defines the maximum number of items to display on a single page. Used to control pagination size.', example: '5' },
  total_pages: { type: 'integer', description: 'Defines the maximum number of pages in a paginated list.', example: '5' },
}

export const AddArticlesToTicket = {
  article_id: { type: 'string', format: 'text', description: 'The id of the article', example: '40b2628a-fc49-41d1-bde8-dcd0f04a51b6' },
  quantity: { type: 'integer', description: 'The quantity of the article to be added to the ticket', example: '2' },
  price: { type: 'number', format: 'float', description: 'The price of the article', example: '99.99' },
  type: { type: 'string', description: 'The type of the article association', example: 'fixed', options: ['fixed', 'variable'] },
}

export const AddPropertiesWithAttributesToServiceHistory = {
  attribute_name: { type: 'string', description: 'The service property attribute' },
  value: { type: 'string', description: 'The value of service property' },
}

export const NestedArticleActionResponse = {
  id: { type: 'string', description: 'The unique identifier of the article', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const NestedActionRecipeResponse = {
  id: { type: 'string', description: 'The unique identifier of the action.', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the action.', example: 'action one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  price: { type: 'number', format: 'float', description: 'The price of the action.', example: '45.1' },
  type: { type: 'string', description: 'The type of the action.', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection'] },
  status: { type: 'string', description: 'The status of the action.', example: 'active', options: ['active', 'inactive'] },
}

export const FetchActionResponseLite = {
  id: { type: 'string', description: 'The unique identifier of the action.', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the action.', example: 'action one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  price: { type: 'number', format: 'float', description: 'The price of the action.', example: '45.1' },
  type: { type: 'string', description: 'The type of the action.', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection'] },
  status: { type: 'string', description: 'The status of the action.', example: 'active', options: ['active', 'inactive'] },
  created_at: { type: 'string', format: 'date', description: 'The created date of the action', example: '2024-01-01' },
  action_type: { type: 'string', example: 'action', options: ['recipe', 'action'] },
}

export const FetchRecipeResponseLite = {
  id: { type: 'string', description: 'The unique identifier of the action.', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the action.', example: 'action one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  price: { type: 'number', format: 'float', description: 'The price of the action.', example: '45.2' },
  type: { type: 'string', description: 'The type of the action.', example: 'repair', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection'] },
  status: { type: 'string', description: 'The status of the action.', example: 'active', options: ['active', 'inactive'] },
  contract_eligible: { type: 'boolean', example: 'false' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the action', example: '2024-01-01' },
  action_type: { type: 'string', example: 'recipe', options: ['recipe', 'action'] },
}

export const NestedArticleOptionResponse = {
  id: { type: 'string', description: 'The unique identifier of the article option', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  external_reference: { type: 'string', description: 'The external id of the article option', example: 'b79225e2846', pattern: '/[^a-zA-Z0-9\\s]/' },
  brand_name: { type: 'string', description: 'The brand name of the article', example: 'Shell', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  code: { type: 'string', description: 'The code of the article', example: 'OIL', pattern: '/^[a-zA-Z0-9\\-_+\\s]+$/' },
  purchase_gross_price: { type: 'number', format: 'float', description: 'The purchase gross price of the article', example: '100' },
  purchase_net_price: { type: 'number', format: 'float', description: 'The purchase net price of the article', example: '100' },
  purchase_discount: { type: 'number', format: 'float', description: 'The purchase net price of the article', example: '4.2' },
  location: { type: 'string', description: 'The location of the article', example: 'A3', pattern: '/^[a-zA-Z0-9\\s]+$/' },
  status: { type: 'string', description: 'The status of the article', example: 'active', options: ['active', 'inactive'] },
  supplier: { type: 'object', ref: 'NestedSupplierResponse' },
}

export const FetchArticleResponseLite = {
  id: { type: 'string', description: 'The unique identifier of the article.', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  measurement: { type: 'string', description: 'The measurement of the article', example: 'piece', options: ['liter', 'kilogram', 'piece'] },
  minimum_margin: { type: 'number', format: 'integer', description: 'The minimum margin of the article', example: '100' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '100' },
  description: { type: 'string', description: 'The description of the article', example: 'description|null' },
  preferred_article_option: { type: 'string' },
}

export const FetchSaleHistoryResponse = {
  id: { type: 'string', description: 'The unique identifier of the sale history', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  price: { type: 'number', format: 'float', description: 'The price of the sale history', example: '10.5' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the sale history', example: '100' },
  article: { type: 'object', ref: 'NestedArticleResponse' },
  sale_date: { type: 'string', format: 'date', description: 'The sale date of the sale history', example: '2020-01-01' },
  ticket_id: { type: 'string', description: 'The ticket id of the sale history', example: 'a1f53581-b6b6-41f1-8c87-cc670fed0fa8' },
  measurement: { type: 'string', description: 'The measurement of ths sale history', example: 'kilogram', options: ['liter', 'kilogram', 'piece'] },
  description: { type: 'string', description: 'The description of the sale history', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the sale history', example: '2020-01-01' },
}

export const FetchPurchaseHistoryResponse = {
  id: { type: 'string', description: 'The unique identifier of the purchase history', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  article: { type: 'object', ref: 'NestedArticleResponse' },
  price: { type: 'number', format: 'float', description: 'The price of the purchase history', example: '10.7' },
  price_per_unit: { type: 'number', format: 'float', description: 'The price per unit of the purchase history', example: '0.5' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the purchase history', example: '100' },
  purchase_date: { type: 'string', format: 'date', description: 'The purchase date of the purchase history', example: '2020-01-01' },
  supplier: { type: 'object', ref: 'NestedSupplierResponse' },
  description: { type: 'string', description: 'The description of the purchase history', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the purchase history', example: '2020-01-01' },
}

export const NestedSupplierResponse = {
  id: { type: 'string', description: 'The unique identifier of the supplier', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  external_reference: { type: 'string', description: 'The external reference of the supplier', example: '122344', pattern: '/[^a-zA-Z0-9\\s]/' },
  name: { type: 'string', description: 'The name of the supplier', example: 'supplier one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const NestedContactDetailResponse = {
  id: { type: 'string', description: 'The unique identifier of the contact detail', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  phone_number: { type: 'string', description: 'The phone number of the contact detail', example: '3100000000', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact detail', example: '3100000000', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact detail', example: 'email@gmail.com' },
}

export const NestedOrganisationContactPerson = {
  id: { type: 'string', description: 'The unique identifier of the contact person', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  salutation: { type: 'string', description: 'The salutation of the contact person', example: 'Mr', options: ['Mr', 'Ms', 'Mrs'] },
  initial: { type: 'string', description: 'The initial of the contact person', example: 'J.G.', pattern: '/[^A-Z.]/' },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo', pattern: '/^[a-zA-Z\\s]+$/' },
  middle_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon', pattern: '/^[a-zA-Z\\s]+$/' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com' },
  active: { type: 'boolean', description: 'The active of the contact person', example: 'true' },
  description: { type: 'string', description: 'The description of the contact person', example: 'some description|null' },
}

export const NestedAddressResponse = {
  id: { type: 'string', description: 'The unique identifier of the address.', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  street: { type: 'string', description: 'The street of the address.', example: 'Ambystraat', pattern: '/[^a-zA-Z\\s\\-\\`\']/' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the address.', example: '5' },
  post_code: { type: 'string', description: 'The post code of the address.', example: '5676YU', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  city: { type: 'string', description: 'The city of the address.', example: 'Amsterdam', pattern: '/[^a-zA-Z\\s\'\\-]/' },
  country: { type: 'string', description: 'The country of the address.', example: 'Netherlands', pattern: '/[^a-zA-Z\\s]/' },
  house_number_extension: { type: 'string', description: 'The house number extension of the address', example: 'A|null', pattern: '/[^a-zA-Z0-9\\s\\-]/' },
  description: { type: 'string', description: 'The description of the address', example: 'description|null' },
}

export const NestedAddressWithContacDetailResponse = {
  id: { type: 'string', description: 'The unique identifier of the address.', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  street: { type: 'string', description: 'The street of the address.', example: 'Ambystraat', pattern: '/[^a-zA-Z\\s\\-\\`\']/' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the address.', example: '5' },
  post_code: { type: 'string', description: 'The post code of the address.', example: '5676YU', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  city: { type: 'string', description: 'The city of the address.', example: 'Amsterdam', pattern: '/[^a-zA-Z\\s\'\\-]/' },
  country: { type: 'string', description: 'The country of the address.', example: 'Netherlands', pattern: '/[^a-zA-Z\\s]/' },
  house_number_extension: { type: 'string', description: 'The house number extension of the address', example: 'A|null', pattern: '/[^a-zA-Z0-9\\s\\-]/' },
  description: { type: 'string', description: 'The description of the address', example: 'description|null' },
  contact_detail: { type: 'object', ref: 'NestedContactDetailResponse' },
}

export const NestedOrganisationFileResponse = {
  id: { type: 'string', description: 'The unique identifier of the file', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the file', example: '8c9da2a5-fee0-4764-aaaf-ca3c7bdccf58.jpg' },
  type: { type: 'string', description: 'The type of the file', example: 'logo', options: ['logo'] },
}

export const FetchOrganisationResponseLite = {
  id: { type: 'string', description: 'The unique identifier of the organisation', example: 'a5039c7e-88e5-4926-9562-60bcd2f88cee' },
  number: { type: 'number', format: 'integer', description: 'The number of the organisation', example: '23535' },
  name: { type: 'string', description: 'The name of the organisation', example: 'organisation name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  vat_number: { type: 'string', description: 'The VAT number of the organisation', example: 'NL686798079', pattern: '/[a-zA-Z0-9\\s]/' },
  chamber_of_commerce_number: { type: 'string', description: 'The chamber of commerce number of the organisation', example: '123456789', pattern: '/^[0-9\\s]+$/' },
  status: { type: 'string', description: 'The status of the organisation', example: 'active', options: ['active', 'inactive'] },
  type: { type: 'string', description: 'The type of the organisation', example: 'prospect', options: ['customer', 'prospect'] },
  payment_method: { type: 'string', description: 'The payment method of the organisation', example: 'sepa', options: ['cash', 'account', 'sepa'] },
  payment_term: { type: 'string', description: 'The payment term of the organisation', example: '14 days', options: ['SEPA', '14 days', '30 days', '60 days'] },
  transport_type: { type: 'string', description: 'The transport type of the organisation', example: 'per ride', options: ['per hour', 'per ride', 'self transport'] },
  transport_ride_amount: { type: 'number', format: 'float', description: 'The transport ride amount of the organisation', example: '200.1' },
  supplier: { type: 'boolean', description: 'The supplier of the organisation', example: 'false' },
  po_required: { type: 'boolean', description: 'The po required of the organisation', example: 'true' },
  active: { type: 'boolean', description: 'Discribes whether organisation is active or not', example: 'false' },
  external_reference: { type: 'string', description: 'The external reference of the organisation', example: '3435t|null' },
  description: { type: 'string', description: 'The description of the organisation', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the organisation', example: '2024-01-01' },
}

export const NestedOrganisationResponse = {
  id: { type: 'string', description: 'The unique identifier of the organisation', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the organisation', example: 'new organisation', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const NestedAssignmentResponse = {
  id: { type: 'string', description: 'The unique identifier of the assignment', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const NestedAssigneeResponse = {
  id: { type: 'string', description: 'The unique identifier of the assignee', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the assignee', example: 'Yan', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  function: { type: 'string', description: 'The function of the assignee', example: 'mechanic', options: ['mechanic'] },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the assignee', example: '70.55' },
}

export const NestedUserResponse = {
  id: { type: 'string', description: 'The unique identifier of the user', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  first_name: { type: 'string', description: 'The first name of the user', example: 'Leo', pattern: '/^[a-zA-Z\\s]+$/' },
  last_name: { type: 'string', description: 'The last name of the user', example: 'Tryon', pattern: '/^[a-zA-Z\\s]+$/' },
  middle_name: { type: 'string', description: 'The middle name of the user', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
}

export const NestedActionResponse = {
  id: { type: 'string', description: 'The unique identifier of the action.', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const NestedActionLabourResponse = {
  id: { type: 'string', description: 'The unique identifier of the action labour', example: 'dc82adb4-cb0d-466b-91bb-cae3d437aaa6' },
  total_hours: { type: 'number', format: 'float', description: 'The total hours of the action labour', example: '10.35' },
  type: { type: 'string', description: 'The type of the action labour', example: 'fixed', options: ['fixed', 'variable'] },
  date: { type: 'date', description: 'The date of the action labour', example: '2026-04-12' },
  assignee: { type: 'object', ref: 'NestedAssigneeResponse2' },
}

export const NestedTicketResponse = {
  id: { type: 'string', description: 'The unique identifier of the ticket', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the ticket', example: 'fixed', options: ['fixed', 'variable'] },
  title: { type: 'string', description: 'The title of the ticket', example: 'new title', pattern: '/^[a-zA-Z\\s]+$/' },
  number: { type: 'number', format: 'integer', description: 'The number of the ticket', example: '10' },
  status: { type: 'object', ref: 'NestedTicketStatus' },
}

export const FetchCommentResponse = {
  id: { type: 'string', description: 'The unique identifier of the comment', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  access_level: { type: 'string', description: 'The access level of the comment', example: 'internal', options: ['public', 'internal'] },
  content: { type: 'string', description: 'The content of the comment', example: 'My review' },
  type: { type: 'string', description: 'The type of the comment', example: 'user', options: ['user', 'case'] },
  author: { type: 'object', ref: 'NestedUserResponse' },
  ticket: { type: 'object', ref: 'NestedTicketResponse' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the comment', example: '2024-01-01' },
}

export const NestedTicketStatus = {
  id: { type: 'string', description: 'The unique identifier of the ticket status', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the ticket status', example: 'new' },
  visible_on_board: { type: 'boolean', description: 'The ticket is displayed on the board', example: 'true' },
  label: { type: 'string', description: 'The label of the ticket status', example: 'new Ticket' },
  business_identifier: { type: 'string', description: 'The business identifier of the ticket status', example: 'NEW' },
}

export const NestedTicketStatusDetail = {
  id: { type: 'string', description: 'The unique identifier of the ticket status detail', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the ticket status detail', example: 'offer' },
  business_identifier: { type: 'string', description: 'The business identifier of the ticket status detail', example: 'NEW' },
}

export const NestedUnitInTicketResponse = {
  id: { type: 'string', description: 'The unique identifier of the unit', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
}

export const NestedSiteResponse = {
  id: { type: 'string', description: 'The unique identifier of the site', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the site', example: 'VDK Verhuur' },
  street: { type: 'string', description: 'The street of the site', example: 'Bloemstraat|null', pattern: '/[^a-zA-Z\\s\\-\\`\']/' },
  house_number: { type: 'number', format: 'integer', description: 'The house number of the site', example: '89' },
  house_number_extension: { type: 'string', description: 'The house number extension of the site', example: 'A|null', pattern: '/[^a-zA-Z0-9\\s\\-]/' },
  post_code: { type: 'string', description: 'The post code of the site', example: '6786PO|null', pattern: '/^[1-9][0-9]{3}?[A-Z]{2}$/i' },
  city: { type: 'string', description: 'The city of the site', example: 'Amsterdam', pattern: '/[^a-zA-Z\\s\'\\-]/' },
  country: { type: 'string', description: 'The country of the site', example: 'Netherlands', pattern: '/[^a-zA-Z\\s]/' },
  description: { type: 'string', description: 'The description of the site', example: 'description|null' },
}

export const NestedAssignmentResponse2 = {
  id: { type: 'string', description: 'The unique identifier of the assignment', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  status: { type: 'string', description: 'The status of the assignment', example: 'open', options: ['open', 'closed'] },
  type: { type: 'string', description: 'The type of the assignment', example: 'fixed', options: ['fixed', 'variable'] },
  action: { type: 'string', description: 'The unique identifier of the action', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  action_type: { type: 'string', description: 'The type of the action', example: 'action', options: ['action', 'recipe'] },
}

export const NestedCommentResponse = {
  id: { type: 'string', description: 'The unique identifier of the comment', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  access_level: { type: 'string', description: 'The access level of the comment', example: 'internal', options: ['public', 'internal'] },
  content: { type: 'string', description: 'The content of the comment', example: 'My review' },
  type: { type: 'string', description: 'The type of the comment', example: 'user', options: ['user', 'case'] },
  created_at: { type: 'string', format: 'date', description: 'The created date of the comment', example: '2024-01-01' },
  author: { type: 'object', ref: 'NestedUserResponse' },
}

export const NestedTicketArticleResponse = {
  id: { type: 'string', description: 'The unique identifier of the article', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  association_id: { type: 'string', description: 'The unique identifier of the ticket article association', example: '9t477ac7-0ce0-485e-b64f-39f882a9f055' },
  external_reference: { type: 'string', description: 'The external id of the article', example: '57gyu78PO', pattern: '/[^a-zA-Z0-9\\s]/' },
  brand_name: { type: 'string', description: 'The brand name of the article', example: 'Shell', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  code: { type: 'string', description: 'The code of the article', example: 'OIL5', pattern: '/^[a-zA-Z0-9\\-_+\\s]+$/' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '10.5' },
  purchase_gross_price: { type: 'number', format: 'float', description: 'The purchase gross price of the article', example: '11.5' },
  purchase_net_price: { type: 'number', format: 'float', description: 'The purchase net price of the article', example: '8.5' },
  measurement: { type: 'string', description: 'The measurement of the article', example: 'liter', options: ['liter', 'kilogram', 'piece'] },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the article', example: '5' },
  type: { type: 'string', description: 'The type of the article association', example: 'fixed', options: ['fixed', 'variable'] },
  location: { type: 'string', description: 'The location of the article ', example: 'CA00' },
}

export const NestedTicketContactPerson = {
  id: { type: 'string', description: 'The unique identifier of the contact', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  reference: { type: 'string', description: 'The type of the contact', example: 'site', options: ['site', 'organisation'] },
  first_name: { type: 'string', description: 'The first name of the contact person', example: 'Leo|null', pattern: '/^[a-zA-Z\\s]+$/' },
  middle_name: { type: 'string', description: 'The middle name of the contact person', example: 'V.|null', pattern: '/^[a-zA-Z\\s\\.]+$/' },
  last_name: { type: 'string', description: 'The last name of the contact person', example: 'Tryon|null', pattern: '/^[a-zA-Z\\s]+$/' },
  phone_number: { type: 'string', description: 'The phone number of the contact person', example: '317908086|null', pattern: '/^31[0-9]{9}$/' },
  mobile_phone_number: { type: 'string', description: 'The mobile phone number of the contact person', example: '3157698870|null', pattern: '/^31[0-9]{9}$/' },
  email: { type: 'string', description: 'The email of the contact person', example: 'email@gmail.com|null' },
}

export const NestedFileResponse = {
  id: { type: 'string', description: 'The unique identifier of the file', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the file', example: 'image', options: ['image', 'signature'] },
}

export const NestedAcknowledgement = {
  id: { type: 'string', description: 'The unique identifier of the contract', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  first_name: { type: 'string', description: 'Signer first name', example: 'John' },
  last_name: { type: 'string', description: 'Signer last name', example: 'Doe' },
  phone_number: { type: 'string', description: 'Signer phone number', example: '31612345678' },
  email: { type: 'string', description: 'Signer email address', example: 'test@mail.com' },
  signature: { type: 'object', ref: 'NestedSignature' },
  ip_address: { type: 'string', description: 'IP address', example: '127.0.0.1' },
  device_information: { type: 'string', format: 'text', example: 'Mozilla/5.0 (iPhone; CPU iPhone OS 15_0 like Mac OS X)' },
  consent: { type: 'boolean', example: 'true' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the acknowledgement', example: '2025-01-01' },
}

export const NestedCase = {
  id: { type: 'string', description: 'The unique identifier of the case', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the case', example: 'geen vervolg' },
  business_identifier: { type: 'string', description: 'The business identifier of the case', example: 'NEW' },
}

export const NestedCaseDetail = {
  id: { type: 'string', description: 'The unique identifier of the case detail', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the case detail', example: 'vegen' },
  business_identifier: { type: 'string', description: 'The business identifier of the case detail', example: 'NEW' },
}

export const FetchTicketResponseFull = {
  id: { type: 'string', description: 'The unique identifier of the ticket', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the ticket', example: 'fixed', options: ['fixed', 'dynamic'] },
  title: { type: 'string', description: 'The title of the ticket', example: 'new title', pattern: '/^[a-zA-Z\\s]+$/' },
  number: { type: 'number', format: 'integer', description: 'The number of the ticket', example: '10' },
  status: { type: 'object', ref: 'NestedTicketStatus' },
  status_detail: { type: 'object', ref: 'NestedTicketStatusDetail' },
  priority: { type: 'string', description: 'The priority of the ticket', example: 'medium|null', options: ['high', 'medium', 'lows'] },
  expected_complete_date: { type: 'string', format: 'date', description: 'The expected complete date of the ticket', example: '2000-01-01|null' },
  expected_duration: { type: 'object', description: 'The expected duration of the ticket', example: '[object Object]' },
  pinned: { type: 'boolean', example: 'false' },
  scheduled_date: { type: 'string', format: 'dateTime', description: 'Scheduled date cannot be in the past', example: '2025-01-01 09:00:00|null' },
  unit: { type: 'string' },
  assignee: { type: 'string' },
  site: { type: 'string' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
  description: { type: 'string', description: 'The description of the ticket', example: 'the machine requires service' },
  assignments: { type: 'array', ref: 'NestedAssignmentResponse2' },
  children: { type: 'array', ref: 'NestedTicketResponse' },
  parent: { type: 'string' },
  comments: { type: 'array', ref: 'NestedCommentResponse2' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the ticket', example: '2024-01-01' },
  article_associations: { type: 'array', ref: 'NestedTicketArticleAssociationResponse' },
  site_contact_persons: { type: 'array', ref: 'NestedTicketContactPerson' },
  organisation_contact_persons: { type: 'array', ref: 'NestedTicketContactPerson' },
  files: { type: 'array', ref: 'NestedFileResponse' },
  case: { type: 'string' },
  case_detail: { type: 'object', ref: 'NestedCaseDetail' },
}

export const NestedUserAssigneeResponse = {
  id: { type: 'string', description: 'The unique identifier of the assignee', example: 'dc82adb4-cb0d-466b-91bb-cae3d437aaa6' },
  name: { type: 'string', description: 'The name of the assignee', example: 'John' },
  function: { type: 'string', description: 'The function of the assignee', example: 'mechanic', options: ['mechanic'] },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the assignee', example: '70.55' },
}

export const FetchTicketStatusResponse = {
  id: { type: 'string', description: 'The unique identifier of the ticket status', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the ticket status', example: 'new' },
  visible_on_board: { type: 'boolean', description: 'The ticket is displayed on the board', example: 'true' },
  label: { type: 'string', description: 'The label of the ticket status', example: 'new Ticket' },
  business_identifier: { type: 'string', description: 'The business identifier of the ticket status', example: 'NEW' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the ticket', example: '2024-01-01' },
  status_details: { type: 'array', ref: 'NestedTicketStatusDetail' },
  allowed_transitions: { type: 'array', ref: 'NestedAllowedTransitions' },
}

export const FetchBookedHoursResponse = {
  date: { type: 'string', format: 'date-time', description: 'The date and time of the booked hours', example: '2025-04-01 00:00:00' },
  number_of_hours: { type: 'number', format: 'float', description: 'The number of hours booked', example: '10' },
}

export const NestedRecipeResponse = {
  id: { type: 'string', description: 'The unique identifier of the recipe', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the recipe', example: 'new recipe', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  type: { type: 'string', description: 'The type of the recipe', example: 'safety inspection', options: ['safety inspection', 'part replacement'] },
}

export const NestedPropertyResponse = {
  id: { type: 'string', description: 'The unique identifier of the property', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  value: { type: 'string', description: 'The value of the property', example: '48V', pattern: '/[^a-zA-Z0-9\\s\\-\\/\\.]/' },
  attribute: { type: 'object', ref: 'NestedPropertyAttributeResponse2' },
}

export const NestedPropertyAttributeResponse = {
  id: { type: 'string', description: 'The unique identifier of the property attribute', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the property attribute', example: 'Power', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const NestedUnitResponse = {
  id: { type: 'string', description: 'The unique identifier of the unit', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/' },
  availability_date: { type: 'string', format: 'date', description: 'The availability date of the unit', example: '2000-01-01' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  manufactured_year: { type: 'number', format: 'integer', description: 'The manufactured year of the unit', example: '2000' },
  status: { type: 'string', description: 'The status of the unit', example: 'active', options: ['active', 'inactive', 'deleted'] },
}

export const NestedActionItemResponse = {
  id: { type: 'string', description: 'The unique identifier of the action item', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  price: { type: 'number', format: 'float', description: 'The price of the action item', example: '50.5' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the action item', example: '100' },
  recipe_name: { type: 'string', description: 'The name of the recipe', example: 'new recipe' },
  recipe_type: { type: 'string', description: 'The type of the recipe', example: 'safety inspection', options: ['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection'] },
  interval_in_months: { type: 'number', format: 'integer', description: 'The interval in months of the action item' },
  hourly_running_rate: { type: 'number', format: 'integer', description: 'The hourly running rate of the action item' },
  running_hours_per_year: { type: 'number', format: 'integer', description: 'The running hours per year of the action item' },
  running_hour_bat_start: { type: 'number', format: 'integer', description: 'The running hour B at start of the action item' },
}

export const NestedContractFileResponse = {
  id: { type: 'string', description: 'The unique identifier of the file', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  filename: { type: 'string', description: 'The name of the file', example: '8c9da2a5-fee0-4764-aaaf-ca3c7bdccf58.jpg' },
  type: { type: 'string', description: 'The type of the file', example: 'logo', options: ['logo'] },
  uri: { type: 'string', description: 'The uri of the file', example: 'https://example.com/image' },
}

export const NestedOrganisationDetailResponse = {
  id: { type: 'string', description: 'The unique identifier of the organisation', example: 'a5039c7e-88e5-4926-9562-60bcd2f88cee' },
  number: { type: 'number', format: 'integer', description: 'The number of the organisation', example: '23535' },
  name: { type: 'string', description: 'The name of the organisation', example: 'organisation name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  po_required: { type: 'boolean', description: 'The po required of the organisation', example: 'true' },
  vat_number: { type: 'string', description: 'The VAT number of the organisation', example: 'NL686798079', pattern: '/[a-zA-Z0-9\\s]/' },
  chamber_of_commerce_number: { type: 'string', description: 'The chamber of commerce number of the organisation', example: '123456789', pattern: '/^[0-9\\s]+$/' },
  status: { type: 'string', description: 'The status of the organisation', example: 'active', options: ['active', 'inactive'] },
  supplier: { type: 'boolean', description: 'The supplier of the organisation', example: 'false' },
  active: { type: 'boolean', description: 'Discribes whether organisation is active or not', example: 'false' },
  type: { type: 'string', description: 'The type of the organisation', example: 'prospect', options: ['customer', 'prospect'] },
  payment_method: { type: 'string', description: 'The payment method of the organisation', example: 'sepa', options: ['cash', 'account', 'sepa'] },
  payment_term: { type: 'string', description: 'The payment term of the organisation', example: '14 days', options: ['SEPA', '14 days', '30 days', '60 days'] },
  transport_type: { type: 'string', description: 'The transport type of the organisation', example: 'per ride', options: ['per hour', 'per ride', 'self transport'] },
  transport_ride_amount: { type: 'number', format: 'float', description: 'The transport ride amount of the organisation', example: '200.1' },
  address: { type: 'object', ref: 'NestedAddressWithContacDetailResponse' },
}

export const NestedUnitDetailResponse = {
  id: { type: 'string', description: 'The unique identifier of the unit', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/' },
  availability_date: { type: 'string', format: 'date', description: 'The availability date of the unit', example: '2000-01-01' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  manufactured_year: { type: 'number', format: 'integer', description: 'The manufactured year of the unit', example: '2000' },
  status: { type: 'string', description: 'The status of the unit', example: 'active', options: ['active', 'inactive', 'deleted'] },
  organisation_id: { type: 'string', description: 'The unique identifier of the organisation', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  category: { type: 'object', ref: 'NestedCategoryResponse' },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '/^[A-Z0-9\\s\\-]/' },
  description: { type: 'string', description: 'The description of the unit', example: 'description|null' },
}

export const NestedActionItemsDetailResponse = {
  id: { type: 'string', description: 'The unique identifier of the action item', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  price: { type: 'number', format: 'float', description: 'The price of the action item', example: '50.5' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the action item', example: '100' },
  recipe: { type: 'object', ref: 'NestedRecipeResponse' },
}

export const NestedServicePropertyResponse = {
  id: { type: 'string', description: 'The unique identifier of the property', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  value: { type: 'string', description: 'The value of the property', example: '48V', pattern: '/[^a-zA-Z0-9\\s\\-\\/\\.]/' },
  attribute: { type: 'object', ref: 'FetchServicePropertyAttributeResponse' },
}

export const NestedCategoryResponse = {
  id: { type: 'string', description: 'The unique identifier of the category', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the category', example: 'new category', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const NestedUnitServicePropertyResponse = {
  id: { type: 'string', description: 'The unique identifier of the property', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  value: { type: 'string', description: 'The value of the property', example: '48V', pattern: '/[^a-zA-Z0-9\\s\\-\\/\\.]/' },
  attribute: { type: 'object', ref: 'NestedPropertyAttributeResponse' },
}

export const NestedServiceHistoryResponse = {
  id: { type: 'string', description: 'The unique identifier of the inspection history', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  ticket_id: { type: 'string', description: 'The unique identifier of the ticket in the inspection history', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the inspection history', example: 'safety inspection', options: ['annual inspection', 'safety inspection', 'general', 'maintenance'] },
  service_date: { type: 'string', format: 'date', description: 'The inspection date of the inspection history', example: '2024-09-01' },
  next_service_date: { type: 'string', format: 'date', description: 'The next inspection date of the inspection history', example: '2024-12-01' },
}

export const NestedContractResponse = {
  id: { type: 'string', description: 'The unique identifier of the contract', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  type: { type: 'string', description: 'The type of the contract', example: 'care', options: ['care', 'full_care'] },
  number: { type: 'number', format: 'integer', description: 'The number of the contract', example: '6870' },
  status: { type: 'string', description: 'The status of the contract', example: 'new', options: ['new', 'active', 'offer', 'ended', 'cancelled', 'expired'] },
  start_date: { type: 'string', format: 'date', description: 'The start date of the contract', example: '2000-01-01' },
  period: { type: 'string', description: 'The period of the contract in months', example: '48', options: ['24', '36', '48', '60', '72', '84', 'indefinite'] },
  end_date: { type: 'string', format: 'date', description: 'The end date of the contract', example: '2000-01-01' },
  annual_price_adjustment: { type: 'boolean', description: 'The annual price adjustment of the contract', example: 'true' },
  description: { type: 'string', description: 'The description of the contract', example: 'description|null' },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the contract', example: '20.5' },
  max_number_of_hours: { type: 'integer', description: 'The max number of hours of the contract', example: '100' },
  contract_holder_contact_person_id: { type: 'string', description: 'The contract holder contact person identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  operator_branch_id: { type: 'string', description: 'The operator branch identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const FetchUnitResponseLite = {
  id: { type: 'string', description: 'The unique identifier of the unit', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/' },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '/^[A-Z0-9\\s\\-]/' },
  organisation: { type: 'object', ref: 'NestedOrganisationResponse' },
  availability_date: { type: 'string', format: 'date', description: 'The availability date of the unit', example: '2000-01-01' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  manufactured_year: { type: 'number', format: 'integer', description: 'The manufactured year of the unit', example: '2000' },
  status: { type: 'string', description: 'The status of the unit', example: 'active', options: ['active', 'inactive', 'deleted'] },
  category: { type: 'object', ref: 'NestedCategoryResponse' },
  description: { type: 'string', description: 'The description of the unit', example: 'description|null' },
  created_at: { type: 'string', format: 'date', description: 'The created date of the unit', example: '2024-04-01' },
}

export const NestedPropertyAttributeResponse2 = {
  id: { type: 'string', description: 'The unique identifier of the property attribute', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the property attribute', example: 'Power', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const FetchCaseResponse = {
  id: { type: 'string', description: 'The unique identifier of the case', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the case', example: 'facilitair' },
  business_identifier: { type: 'string', description: 'The business identifier of the case', example: 'NEW' },
  case_details: { type: 'array', description: 'The detail of the case', ref: 'NestedCaseDetail' },
}

export const NestedArticleOptionForLiteArticleResponse = {
  id: { type: 'string', description: 'The unique identifier of the article option', example: '13ff6079-42f8-43fc-a928-5b79225e2846' },
  external_reference: { type: 'string', description: 'The external id of the article option', example: 'b79225e2846', pattern: '/[^a-zA-Z0-9\\s]/' },
  brand_name: { type: 'string', description: 'The brand name of the article', example: 'Shell', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  code: { type: 'string', description: 'The code of the article', example: 'OIL', pattern: '/^[a-zA-Z0-9\\-_+\\s]+$/' },
}

export const NestedArticleResponse = {
  id: { type: 'string', description: 'The unique identifier of the article', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  measurement: { type: 'string', description: 'The measurement of the article', example: 'liter', options: ['liter', 'kilogram', 'piece'] },
  minimum_margin: { type: 'number', format: 'integer', description: 'The minimum margin of the article', example: '100' },
  sale_price: { type: 'number', format: 'float', description: 'The sale price of the article', example: '10.5' },
}

export const NestedAssigneeResponse2 = {
  id: { type: 'string', description: 'The unique identifier of the assignee', example: 'dc82adb4-cb0d-466b-91bb-cae3d437aaa6' },
  name: { type: 'string', description: 'The name of the assignee', example: 'John' },
  price_per_hour: { type: 'number', format: 'float', description: 'The price per hour of the assignee', example: '18.3' },
}

export const NestedUnitInTicketResponse2 = {
  name: { type: 'string', description: 'The name of the unit', example: 'unit one', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  fleet_number: { type: 'number', format: 'integer', description: 'The fleet number of the unit', example: '1000' },
  serial_number: { type: 'string', description: 'The serial number of the unit', example: 'HG000000', pattern: '/^[a-zA-Z0-9]+$/' },
  license_plate_number: { type: 'string', description: 'The license plate number of the unit', example: 'HG100-00|null', pattern: '/^[A-Z0-9\\s\\-]/' },
  manufacture_name: { type: 'string', description: 'The manufacture name of the unit', example: 'some name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  category_name: { type: 'string', description: 'The category name of the unit', example: 'category name', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
}

export const NestedCommentResponse2 = {
  id: { type: 'string', description: 'The unique identifier of the comment', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  access_level: { type: 'string', description: 'The access level of the comment', example: 'internal', options: ['public', 'internal'] },
  content: { type: 'string', description: 'The content of the comment', example: 'My review' },
}

export const NestedTicketArticleAssociationResponse = {
  id: { type: 'string', description: 'The unique identifier of the article association', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  article_id: { type: 'string', description: 'The unique identifier of the article', example: '14db9a62-b96b-4cf1-be84-5a4fec653a88' },
  name: { type: 'string', description: 'The name of the article', example: 'Oil', pattern: '/^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$/' },
  quantity: { type: 'number', format: 'integer', description: 'The quantity of the article', example: '3' },
  ticket_id: { type: 'string', description: 'The unique identifier of the ticket', example: '72477ac7-0ce0-485e-b64f-39f882a9f055' },
  price: { type: 'number', format: 'float', description: 'The price of the article', example: '99.99' },
  type: { type: 'string', description: 'The type of the article association', example: 'fixed', options: ['fixed', 'variable'] },
}

export const NestedAllowedTransitions = {
  id: { type: 'string', description: 'The unique identifier of the ticket status', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  name: { type: 'string', description: 'The name of the ticket status', example: 'new' },
  business_identifier: { type: 'string', description: 'The business identifier of the ticket status', example: 'NEW' },
}

// Custom form models

// Still to be implemented in backend (DTO missing from endpoint in controller)

export const CreateCategoryDTO = {
  name: { type: 'string', description: 'The name of the category', example: 'new category', pattern: '.*[a-zA-Z0-9\-/\'\\.,`_&()+\s]+' },
  service_attributes_validation: { type: 'object', format: 'json', description: 'The validation schema for the category service attributes' },
  service_attributes_ui_schema: { type: 'object', format: 'json', description: 'The ui schema for the category service attributes' },
}


export const UpdateCategoryDTO = {
  name: { type: 'string', description: 'The name of the category', example: 'new category', pattern: '.*[a-zA-Z0-9\-/\'\\.,`_&()+\s]+' },
  service_attributes_validation: { type: 'object', format: 'json', description: 'The validation schema for the category service attributes' },
  service_attributes_ui_schema: { type: 'object', format: 'json', description: 'The ui schema for the category service attributes' },
}


export const CreateServicePropertyDTO = {
  value: { type: 'string', description: 'The value of the property', example: '48V', pattern: '.*[a-zA-Z0-9\s\-/\.].*' },
  attribute_id: { type: 'string', description: 'The attribute identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const UpdateServicePropertyDTO = {
  value: { type: 'string', description: 'The value of the property', example: '100', pattern: '.*[a-zA-Z0-9\s\-/\.].*' },
  attribute_id: { type: 'string', description: 'The attribute identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const FetchServicePropertyAttributesDTO = {
  category_id: { type: 'string', description: 'The category identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}

export const FetchServicePropertyResponse = {
  id: { type: 'string', description: 'The identifier of the service property', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
  value: { type: 'string', description: 'The value of the service property', example: '100' },
  attribute_id: { type: 'string', description: 'The attribute identifier', example: '5a27d3ef-abef-44ea-9b17-d5206dfff4c0' },
}


export const formModelRegistry: Record<string, Record<string, { type?: string; ref?: string; format?: string; [k: string]: unknown }>> = {
  CreateActionDTO,
  CreateRecipeDTO,
  AddActionsToRecipeDTO,
  AddArticlesToActionDTO,
  AbstractActionFiltersDTO,
  UpdateActionDTO,
  PatchActionDTO,
  UpdateActionStatusDTO,
  ArticleFiltersDTO,
  CreateArticleDTO,
  PatchArticleDTO,
  CreateSupplierDTO,
  UpdateSupplierDTO,
  CreateSaleHistoryDTO,
  FetchAllSaleHistoriesDTO,
  FetchAllPurchaseHistoriesDTO,
  CreatePurchaseHistoryDTO,
  UpdateArticleOptionStatusDTO,
  CreateArticleOptionDTO,
  PatchArticleOptionDTO,
  AddArticleOptionToArticleDTO,
  CreateAddressDTO,
  OrganisationFilterDTO,
  AddContactPersonToOrganisationDTO,
  AddBranchToOrganisationDTO,
  CreateOrganisationDTO,
  UpdateOrganisationDTO,
  PatchOrganisationDTO,
  ContactPersonFilterDTO,
  CreateOrganisationContactPersonDTO,
  CreateContactDetailDTO,
  SaveOrganisationFileDTO,
  CreateActionLabourDTO,
  AssigneeFiltersDTO,
  CreateAssigneeDTO,
  FetchAllAssignmentsDTO,
  CreateAssignmentDTO,
  AddAssigneeToAssignmentDTO,
  AddActionLabourToAssignmentDTO,
  CreateCommentDTO,
  FetchAllCommentsDTO,
  CreateTicketContactPersonDTO,
  SiteFiltersDTO,
  CreateSiteDTO,
  TicketFiltersDTO,
  CreateTicketDTO,
  UpdateTicketExpectedDurationDTO,
  UpdateTicketOrganisationDTO,
  PatchTicketDTO,
  AddAssigneeToTicketDTO,
  AddChildTicketToTicketDTO,
  AddAssignmentToTicketDTO,
  AddContactPersonsToTicketDTO,
  AddArticlesToTicketDTO,
  AddAcknowledgementToTicketDTO,
  SaveFileDTO,
  AddSignatureDTO,
  UserFiltersDTO,
  CreateUserDTO,
  UpdateTicketOrganisationContactPersonDTO,
  CreateTicketStatusDTO,
  UpdateAssigneeDTO,
  UpdateTicketArticleAssociationPriceDTO,
  UpdateAssignmentAbstractActionDTO,
  PatchActionLabourDTO,
  FetchAllBookedHoursDTO,
  ActionItemFiltersDTO,
  CreateActionItemDTO,
  UpdateActionItemDTO,
  CategoryFiltersDTO,
  CategoryDTO,
  AddPropertiesDTO,
  AddPropertyAttributesDTO,
  CreateContractDTO,
  UpdateContractDTO,
  PatchContractDTO,
  FetchAllContractsDTO,
  UpdateContractStatusDTO,
  AddActionItemsToContractDTO,
  UpdateOrAddNoteToContractDTO,
  AddAcknowledgementToContractDTO,
  CreateServiceHistoryDTO,
  UpdateServiceHistoryDTO,
  AddPropertiesWithAttributesToServiceHistoryDTO,
  CreateMaintenancePackageDTO,
  UpdateMaintenancePackageDTO,
  AddRecipesToMaintenancePackageDTO,
  CreateUnitDTO,
  UpdateUnitDTO,
  PatchUnitDTO,
  UnitFiltersDTO,
  AddServicePropertyToUnitDTO,
  AddServiceHistoryToUnitDTO,
  CreatePropertyDTO,
  UpdatePropertyDTO,
  CreatePropertyAttributeDTO,
  PropertyAttributeFiltersDTO,
  ServicePropertyAttributeFiltersDTO,
  CreateServicePropertyAttributeDTO,
  UpdateUnitStatusDTO,
  AddFileDTO,
  CreateAdjustmentDTO,
  CreateTemplateDTO,
  UpdateTemplateDTO,
  GenerateTemplateDTO,
  AddNewVersionDTO,
  FetchContentDTO,
  PreviewTemplateDTO,
  AddComponentToTemplateDTO,
  CreateComponentDTO,
  UpdateComponentDTO,
  CreateLayoutDTO,
  UpdateLayoutDTO,
  AddTemplateToLayoutDTO,
  CreateStylesheetDTO,
  UpdateStylesheetDTO,
  AddTemplateToStylesheetDTO,
  CreateThemeDTO,
  UpdateThemeDTO,
  AddTemplateToThemeDTO,
  CreateProjectDTO,
  UpdateProjectDTO,
  SendEmailDTO,
  SendContractDTO,
  FetchActionResponse,
  FetchRecipeResponse,
  FetchAllActionsResponse,
  FetchAllRecipesResponse,
  FetchArticleResponse,
  FetchAllArticlesResponse,
  FetchSupplierResponse,
  FetchAllSuppliers,
  FetchAllSaleHistoriesResponse,
  FetchAllPurchaseHistoriesResponse,
  FetchArticleOptionResponse,
  FetchAddressResponse,
  FetchAllAddressesResponse,
  FetchOrganisationResponse,
  FetchAllOrganisations,
  FetchOrganisationContactPersonResponse,
  FetchAllOrganisationContactPersonsResponse,
  FetchAllContactPersonsByOrganisationId,
  FetchAllOrganisationBranchesResponse,
  FetchActionLabourResponse,
  FetchAllActionLabours,
  UpdateActionLabourTotalHours,
  FetchAssigneeResponse,
  FetchAllAssignees,
  FetchAssignmentResponse,
  FetchAllAssignments,
  FetchAllComments,
  FetchTicketContactPersonResponse,
  FetchAllTicketContactPersonsResponse,
  FetchSiteResponse,
  FetchAllSites,
  FetchTicketResponse,
  FetchAllTickets,
  FetchAllScheduledTickets,
  UpdateTicketTitle,
  UpdateTicketDescription,
  UpdateTicketPriority,
  ScheduleTicket,
  UpdateTicketStatus,
  UpdateTicketAssignee,
  UpdateTicketExpectedDuration,
  UpdateTicketOrganisation,
  AddAcknowledgementToTicket,
  AddCaseToTicket,
  NestedSignature,
  FetchFileResponse,
  FetchUserResponse,
  FetchAllUsers,
  UpdateTicketSiteContactPerson,
  FetchAllTicketStatus,
  UpdateTicketArticleAssociationQuantity,
  FetchAllBookedHours,
  FetchActionItemResponse,
  FetchAllActionItems,
  FetchCategoryResponse,
  FetchAllCategoriesResponse,
  FetchContractResponse,
  FetchAllContracts,
  AddAcknowledgementToContract,
  FetchServiceHistoryResponse,
  FetchAllServiceHistoriesResponse,
  FetchMaintenancePackageResponse,
  FetchAllMaintenancePackagesResponse,
  FetchUnitResponse,
  FetchAllUnits,
  FetchPropertyResponse,
  FetchAllPropertiesResponse,
  FetchAllPropertyAttributes,
  FetchServicePropertyAttributeResponse,
  FetchAllServicePropertyAttributesResponse,
  FetchPropertyAttributeResponse,
  FetchAllCases,
  FetchAdjustmentResponse,
  FetchAllAdjustments,
  AddArticlesToTicket,
  AddPropertiesWithAttributesToServiceHistory,
  NestedArticleActionResponse,
  NestedActionRecipeResponse,
  FetchActionResponseLite,
  FetchRecipeResponseLite,
  NestedArticleOptionResponse,
  FetchArticleResponseLite,
  FetchSaleHistoryResponse,
  FetchPurchaseHistoryResponse,
  NestedSupplierResponse,
  NestedContactDetailResponse,
  NestedOrganisationContactPerson,
  NestedAddressResponse,
  NestedAddressWithContacDetailResponse,
  NestedOrganisationFileResponse,
  FetchOrganisationResponseLite,
  NestedOrganisationResponse,
  NestedAssignmentResponse,
  NestedAssigneeResponse,
  NestedUserResponse,
  NestedActionResponse,
  NestedActionLabourResponse,
  NestedTicketResponse,
  FetchCommentResponse,
  NestedTicketStatus,
  NestedTicketStatusDetail,
  NestedUnitInTicketResponse,
  NestedSiteResponse,
  NestedAssignmentResponse2,
  NestedCommentResponse,
  NestedTicketArticleResponse,
  NestedTicketContactPerson,
  NestedFileResponse,
  NestedAcknowledgement,
  NestedCase,
  NestedCaseDetail,
  FetchTicketResponseFull,
  NestedUserAssigneeResponse,
  FetchTicketStatusResponse,
  FetchBookedHoursResponse,
  NestedRecipeResponse,
  NestedPropertyResponse,
  NestedPropertyAttributeResponse,
  NestedUnitResponse,
  NestedActionItemResponse,
  NestedContractFileResponse,
  NestedOrganisationDetailResponse,
  NestedUnitDetailResponse,
  NestedActionItemsDetailResponse,
  NestedServicePropertyResponse,
  NestedCategoryResponse,
  NestedUnitServicePropertyResponse,
  NestedServiceHistoryResponse,
  NestedContractResponse,
  FetchUnitResponseLite,
  NestedPropertyAttributeResponse2,
  FetchCaseResponse,
  NestedArticleOptionForLiteArticleResponse,
  NestedArticleResponse,
  NestedAssigneeResponse2,
  NestedUnitInTicketResponse2,
  NestedCommentResponse2,
  NestedTicketArticleAssociationResponse,
  NestedAllowedTransitions,
}
